/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/booking/filter/booking-filter.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '../../../../../../public/upgrade/core/date.service';
import * as import7 from '../../../../../../public/upgrade/root/ga/ga.service';
import * as import8 from '@angular/core/src/linker/view_type';
import * as import9 from '@angular/core/src/change_detection/constants';
import * as import10 from '@angular/core/src/linker/component_factory';
import * as import11 from '../../../../../../public/upgrade/core/session.service';
import * as import12 from '@ngx-translate/core/src/translate.service';
import * as import13 from '../../../../../node_modules/@angular/forms/src/directives/select_control_value_accessor.ngfactory';
import * as import14 from '../../../../../node_modules/@angular/forms/src/directives/select_multiple_control_value_accessor.ngfactory';
import * as import15 from '@ngx-translate/core/src/translate.pipe';
import * as import16 from '@angular/core/src/linker/view_container';
import * as import17 from '@angular/core/src/linker/element_ref';
import * as import18 from '@angular/forms/src/directives/select_control_value_accessor';
import * as import19 from '@angular/forms/src/directives/select_multiple_control_value_accessor';
import * as import20 from '../../../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import21 from '../../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import22 from '../../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import23 from '../../../core/ngmodel-for-wc.ngfactory';
import * as import24 from '../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import25 from '@angular/core/src/linker/template_ref';
import * as import26 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import27 from '@angular/common/src/directives/ng_for';
import * as import28 from '@angular/forms/src/directives/default_value_accessor';
import * as import29 from '@angular/forms/src/directives/control_value_accessor';
import * as import30 from '@angular/forms/src/directives/ng_model';
import * as import31 from '@angular/forms/src/directives/ng_control';
import * as import32 from '@angular/forms/src/directives/ng_control_status';
import * as import33 from '../../../../../../public/upgrade/core/ngmodel-for-wc';
import * as import34 from '@angular/core/src/linker/query_list';
import * as import35 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import36 from '../../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import37 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import38 from '@angular/common/src/directives/ng_if';
import * as import39 from '@angular/common/src/directives/ng_class';
export class Wrapper_BookingFilterComponent {
  /*private*/ _eventHandler:Function;
  context:import0.BookingFilterComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  subscription0:any;
  subscription1:any;
  subscription2:any;
  subscription3:any;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any) {
    this._changed = false;
    this.context = new import0.BookingFilterComponent(p0,p1,p2,p3,p4);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
    (this.subscription1 && this.subscription1.unsubscribe());
    (this.subscription2 && this.subscription2.unsubscribe());
    (this.subscription3 && this.subscription3.unsubscribe());
  }
  check_data(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.data = currValue;
      this._expr_0 = currValue;
    }
  }
  check_landing(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.landing = currValue;
      this._expr_1 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean,emit1:boolean,emit2:boolean,emit3:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.filter.subscribe(_eventHandler.bind(view,'filter'))); }
    if (emit1) { (this.subscription1 = this.context.pointsOfSale.subscribe(_eventHandler.bind(view,'pointsOfSale'))); }
    if (emit2) { (this.subscription2 = this.context.autocompleteCompany.subscribe(_eventHandler.bind(view,'autocompleteCompany'))); }
    if (emit3) { (this.subscription3 = this.context.autocompleteCities.subscribe(_eventHandler.bind(view,'autocompleteCities'))); }
  }
}
var renderType_BookingFilterComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_BookingFilterComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.BookingFilterComponent>;
  _DateService_0_3:import6.DateService;
  _GAService_0_4:import7.GAService;
  _BookingFilterComponent_0_5:Wrapper_BookingFilterComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_BookingFilterComponent_Host0,renderType_BookingFilterComponent_Host,import8.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'booking-filter',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_BookingFilterComponent0(this.viewUtils,this,0,this._el_0);
    this._DateService_0_3 = new import6.DateService();
    this._GAService_0_4 = new import7.GAService();
    this._BookingFilterComponent_0_5 = new Wrapper_BookingFilterComponent(this._DateService_0_3,this.injectorGet(import11.SessionService,this.parentIndex),this._GAService_0_4,this.injectorGet(import12.TranslateService,this.parentIndex),this.compView_0.ref);
    this.compView_0.create(this._BookingFilterComponent_0_5.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import10.ComponentRef_<any>(0,this,this._el_0,this._BookingFilterComponent_0_5.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import6.DateService) && (0 === requestNodeIndex))) { return this._DateService_0_3; }
    if (((token === import7.GAService) && (0 === requestNodeIndex))) { return this._GAService_0_4; }
    if (((token === import0.BookingFilterComponent) && (0 === requestNodeIndex))) { return this._BookingFilterComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._BookingFilterComponent_0_5.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { this._BookingFilterComponent_0_5.context.ngAfterViewChecked(); }
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._BookingFilterComponent_0_5.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const BookingFilterComponentNgFactory:import10.ComponentFactory<import0.BookingFilterComponent> = new import10.ComponentFactory<import0.BookingFilterComponent>('booking-filter',View_BookingFilterComponent_Host0,import0.BookingFilterComponent);
const styles_BookingFilterComponent:any[] = ([] as any[]);
class View_BookingFilterComponent2 extends import2.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import13.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import14.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  _pipe_translate_0:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_BookingFilterComponent2,renderType_BookingFilterComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',new import3.InlineArray2(2,'class','select-option'),(null as any));
    this._NgSelectOption_0_3 = new import13.Wrapper_NgSelectOption(new import17.ElementRef(this._el_0),this.renderer,(null as any));
    this._NgSelectMultipleOption_0_4 = new import14.Wrapper_NgSelectMultipleOption(new import17.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import19.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = import3.inlineInterpolate(1,'',this.context.$implicit.text,'');
    this._NgSelectOption_0_3.check_value(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = import3.inlineInterpolate(1,'',this.context.$implicit.text,'');
    this._NgSelectMultipleOption_0_4.check_value(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.context.$implicit.value)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingFilterComponent1 extends import2.AppView<any> {
  _el_0:any;
  _DefaultValueAccessor_0_3:import20.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_0_4:any[];
  _NgModel_0_5:import21.Wrapper_NgModel;
  _NgControl_0_6:any;
  _NgControlStatus_0_7:import22.Wrapper_NgControlStatus;
  _NgModelWc_0_8:import23.Wrapper_NgModelWc;
  _text_1:any;
  _el_2:any;
  _NgSelectOption_2_3:import13.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_2_4:import14.Wrapper_NgSelectMultipleOption;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import16.ViewContainer;
  _TemplateRef_5_5:any;
  _NgFor_5_6:import24.Wrapper_NgFor;
  _text_6:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  _pipe_translate_0:import15.TranslatePipe;
  /*private*/ _expr_21:any;
  /*private*/ _expr_22:any;
  _pipe_translate_1:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_BookingFilterComponent1,renderType_BookingFilterComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
    this._expr_21 = import1.UNINITIALIZED;
    this._expr_22 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-select',new import3.InlineArray8(6,'attr.default-value','empty','id','selectDateRange','ngDefaultControl',''),(null as any));
    this._DefaultValueAccessor_0_3 = new import20.Wrapper_DefaultValueAccessor(this.renderer,new import17.ElementRef(this._el_0));
    this._NG_VALUE_ACCESSOR_0_4 = [this._DefaultValueAccessor_0_3.context];
    this._NgModel_0_5 = new import21.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_0_4);
    this._NgControl_0_6 = this._NgModel_0_5.context;
    this._NgControlStatus_0_7 = new import22.Wrapper_NgControlStatus(this._NgControl_0_6);
    this._NgModelWc_0_8 = new import23.Wrapper_NgModelWc(new import17.ElementRef(this._el_0),this._NgModel_0_5.context);
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'option',new import3.InlineArray4(4,'disabled','','value','empty'),(null as any));
    this._NgSelectOption_2_3 = new import13.Wrapper_NgSelectOption(new import17.ElementRef(this._el_2),this.renderer,(null as any));
    this._NgSelectMultipleOption_2_4 = new import14.Wrapper_NgSelectMultipleOption(new import17.ElementRef(this._el_2),this.renderer,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_5 = new import16.ViewContainer(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import25.TemplateRef_(this,5,this._anchor_5);
    this._NgFor_5_6 = new import24.Wrapper_NgFor(this._vc_5.vcRef,this._TemplateRef_5_5,this.parentView.parentView.injectorGet(import26.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_6 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray8(8,'ngModelChange',(null as any),'change',(null as any),'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_0));
    this._NgModel_0_5.subscribe(this,this.eventHandler(this.handleEvent_0),true);
    this._NgModelWc_0_8.subscribe(this,this.eventHandler(this.handleEvent_0),true);
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgSelectOption) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._NgSelectOption_2_3.context; }
    if (((token === import19.NgSelectMultipleOption) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._NgSelectMultipleOption_2_4.context; }
    if (((token === import25.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import27.NgFor) && (5 === requestNodeIndex))) { return this._NgFor_5_6.context; }
    if (((token === import28.DefaultValueAccessor) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._DefaultValueAccessor_0_3.context; }
    if (((token === import29.NG_VALUE_ACCESSOR) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._NG_VALUE_ACCESSOR_0_4; }
    if (((token === import30.NgModel) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._NgModel_0_5.context; }
    if (((token === import31.NgControl) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._NgControl_0_6; }
    if (((token === import32.NgControlStatus) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._NgControlStatus_0_7.context; }
    if (((token === import33.NgModelWc) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._NgModelWc_0_8.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this._DefaultValueAccessor_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.parentView.context.dateTypeSelect;
    this._NgModel_0_5.check_model(currVal_0_1_0,throwOnChange,false);
    this._NgModel_0_5.ngDoCheck(this,this._el_0,throwOnChange);
    this._NgControlStatus_0_7.ngDoCheck(this,this._el_0,throwOnChange);
    this._NgModelWc_0_8.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_2_0_0:any = 'empty';
    this._NgSelectOption_2_3.check_value(currVal_2_0_0,throwOnChange,false);
    this._NgSelectOption_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_2_1_0:any = 'empty';
    this._NgSelectMultipleOption_2_4.check_value(currVal_2_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_2_4.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_5_0_0:any = this.parentView.context.data.dateType;
    this._NgFor_5_6.check_ngForOf(currVal_5_0_0,throwOnChange,false);
    this._NgFor_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_19:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingList.filter.TYPE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_19,currVal_19))) {
      this.renderer.setElementProperty(this._el_0,'label',currVal_19);
      this._expr_19 = currVal_19;
    }
    const currVal_21:any = 'md';
    if (import3.checkBinding(throwOnChange,this._expr_21,currVal_21)) {
      this.renderer.setElementProperty(this._el_0,'size',currVal_21);
      this._expr_21 = currVal_21;
    }
    this._NgControlStatus_0_7.checkHost(this,this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_22:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('common.SELECT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_22,currVal_22))) {
      this.renderer.setText(this._text_3,currVal_22);
      this._expr_22 = currVal_22;
    }
  }
  dirtyParentQueriesInternal():void {
    (<View_BookingFilterComponent0>this.parentView)._viewQuery_selectDateRange_2.setDirty();
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._NgSelectOption_2_3.ngOnDestroy();
    this._NgSelectMultipleOption_2_4.ngOnDestroy();
    this._NgModel_0_5.ngOnDestroy();
    this._NgModelWc_0_8.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_BookingFilterComponent2(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_0_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'ngModelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.dateTypeSelect = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.parentView.context.changeTypeDateSelectValue($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_BookingFilterComponent4 extends import2.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import13.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import14.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  _pipe_translate_0:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_BookingFilterComponent4,renderType_BookingFilterComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',new import3.InlineArray2(2,'class','select-option'),(null as any));
    this._NgSelectOption_0_3 = new import13.Wrapper_NgSelectOption(new import17.ElementRef(this._el_0),this.renderer,(null as any));
    this._NgSelectMultipleOption_0_4 = new import14.Wrapper_NgSelectMultipleOption(new import17.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import19.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = import3.inlineInterpolate(1,'',this.context.$implicit.text,'');
    this._NgSelectOption_0_3.check_value(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = import3.inlineInterpolate(1,'',this.context.$implicit.text,'');
    this._NgSelectMultipleOption_0_4.check_value(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.context.$implicit.value)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingFilterComponent3 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgSelectOption_2_3:import13.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_2_4:import14.Wrapper_NgSelectMultipleOption;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import16.ViewContainer;
  _TemplateRef_5_5:any;
  _NgFor_5_6:import24.Wrapper_NgFor;
  _text_6:any;
  /*private*/ _expr_12:any;
  _pipe_translate_0:import15.TranslatePipe;
  /*private*/ _expr_14:any;
  _pipe_translate_1:import15.TranslatePipe;
  /*private*/ _expr_16:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  _pipe_translate_2:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_BookingFilterComponent3,renderType_BookingFilterComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_12 = import1.UNINITIALIZED;
    this._expr_14 = import1.UNINITIALIZED;
    this._expr_16 = import1.UNINITIALIZED;
    this._expr_17 = import1.UNINITIALIZED;
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-select',new import3.InlineArray8(6,'filter-id','status','id','status','name','Estado'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'option',new import3.InlineArray8(6,'disabled','','selected','','value',''),(null as any));
    this._NgSelectOption_2_3 = new import13.Wrapper_NgSelectOption(new import17.ElementRef(this._el_2),this.renderer,(null as any));
    this._NgSelectMultipleOption_2_4 = new import14.Wrapper_NgSelectMultipleOption(new import17.ElementRef(this._el_2),this.renderer,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_5 = new import16.ViewContainer(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import25.TemplateRef_(this,5,this._anchor_5);
    this._NgFor_5_6 = new import24.Wrapper_NgFor(this._vc_5.vcRef,this._TemplateRef_5_5,this.parentView.parentView.injectorGet(import26.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_6 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_2 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgSelectOption) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._NgSelectOption_2_3.context; }
    if (((token === import19.NgSelectMultipleOption) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._NgSelectMultipleOption_2_4.context; }
    if (((token === import25.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import27.NgFor) && (5 === requestNodeIndex))) { return this._NgFor_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_2_0_0:any = '';
    this._NgSelectOption_2_3.check_value(currVal_2_0_0,throwOnChange,false);
    this._NgSelectOption_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_2_1_0:any = '';
    this._NgSelectMultipleOption_2_4.check_value(currVal_2_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_2_4.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_5_0_0:any = this.parentView.context.data.status;
    this._NgFor_5_6.check_ngForOf(currVal_5_0_0,throwOnChange,false);
    this._NgFor_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_12:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingList.filter.STATUS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_12,currVal_12))) {
      this.renderer.setElementAttribute(this._el_0,'filter-tag',((currVal_12 == null)? (null as any): currVal_12.toString()));
      this._expr_12 = currVal_12;
    }
    valUnwrapper.reset();
    const currVal_14:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingList.filter.BOOKING_STATUS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_14,currVal_14))) {
      this.renderer.setElementProperty(this._el_0,'label',currVal_14);
      this._expr_14 = currVal_14;
    }
    const currVal_16:any = 'md';
    if (import3.checkBinding(throwOnChange,this._expr_16,currVal_16)) {
      this.renderer.setElementProperty(this._el_0,'size',currVal_16);
      this._expr_16 = currVal_16;
    }
    const currVal_17:any = 'Campo invalido!';
    if (import3.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementProperty(this._el_0,'invalid-text',currVal_17);
      this._expr_17 = currVal_17;
    }
    const currVal_18:any = 'top left';
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementProperty(this._el_0,'invalid-position',currVal_18);
      this._expr_18 = currVal_18;
    }
    valUnwrapper.reset();
    const currVal_19:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('common.SELECT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_19,currVal_19))) {
      this.renderer.setText(this._text_3,currVal_19);
      this._expr_19 = currVal_19;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._NgSelectOption_2_3.ngOnDestroy();
    this._NgSelectMultipleOption_2_4.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_BookingFilterComponent4(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
}
class View_BookingFilterComponent6 extends import2.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import13.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import14.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  _pipe_translate_0:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_BookingFilterComponent6,renderType_BookingFilterComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',new import3.InlineArray2(2,'class','select-option'),(null as any));
    this._NgSelectOption_0_3 = new import13.Wrapper_NgSelectOption(new import17.ElementRef(this._el_0),this.renderer,(null as any));
    this._NgSelectMultipleOption_0_4 = new import14.Wrapper_NgSelectMultipleOption(new import17.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import19.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = import3.inlineInterpolate(1,'',this.context.$implicit.oid,'');
    this._NgSelectOption_0_3.check_value(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = import3.inlineInterpolate(1,'',this.context.$implicit.oid,'');
    this._NgSelectMultipleOption_0_4.check_value(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.context.$implicit.name)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingFilterComponent5 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgSelectOption_2_3:import13.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_2_4:import14.Wrapper_NgSelectMultipleOption;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import16.ViewContainer;
  _TemplateRef_5_5:any;
  _NgFor_5_6:import24.Wrapper_NgFor;
  _text_6:any;
  /*private*/ _expr_12:any;
  /*private*/ _expr_13:any;
  _pipe_translate_0:import15.TranslatePipe;
  /*private*/ _expr_15:any;
  _pipe_translate_1:import15.TranslatePipe;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  /*private*/ _expr_20:any;
  _pipe_translate_2:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_BookingFilterComponent5,renderType_BookingFilterComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_12 = import1.UNINITIALIZED;
    this._expr_13 = import1.UNINITIALIZED;
    this._expr_15 = import1.UNINITIALIZED;
    this._expr_17 = import1.UNINITIALIZED;
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
    this._expr_20 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-select',new import3.InlineArray8(8,'default-value','','filter-id','pointOfSaleOID','id','pointOfSaleOID','name','Sucursal'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'option',new import3.InlineArray8(6,'disabled','','selected','','value',''),(null as any));
    this._NgSelectOption_2_3 = new import13.Wrapper_NgSelectOption(new import17.ElementRef(this._el_2),this.renderer,(null as any));
    this._NgSelectMultipleOption_2_4 = new import14.Wrapper_NgSelectMultipleOption(new import17.ElementRef(this._el_2),this.renderer,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_5 = new import16.ViewContainer(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import25.TemplateRef_(this,5,this._anchor_5);
    this._NgFor_5_6 = new import24.Wrapper_NgFor(this._vc_5.vcRef,this._TemplateRef_5_5,this.parentView.parentView.injectorGet(import26.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_6 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_2 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgSelectOption) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._NgSelectOption_2_3.context; }
    if (((token === import19.NgSelectMultipleOption) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._NgSelectMultipleOption_2_4.context; }
    if (((token === import25.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import27.NgFor) && (5 === requestNodeIndex))) { return this._NgFor_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_2_0_0:any = '';
    this._NgSelectOption_2_3.check_value(currVal_2_0_0,throwOnChange,false);
    this._NgSelectOption_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_2_1_0:any = '';
    this._NgSelectMultipleOption_2_4.check_value(currVal_2_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_2_4.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_5_0_0:any = this.parentView.context.data.pointsOfSale;
    this._NgFor_5_6.check_ngForOf(currVal_5_0_0,throwOnChange,false);
    this._NgFor_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    const currVal_12:any = import3.inlineInterpolate(1,'',this.parentView.context.disablePointsOfSale,'');
    if (import3.checkBinding(throwOnChange,this._expr_12,currVal_12)) {
      this.renderer.setElementAttribute(this._el_0,'disabled',((currVal_12 == null)? (null as any): currVal_12.toString()));
      this._expr_12 = currVal_12;
    }
    valUnwrapper.reset();
    const currVal_13:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingList.filter.POINT_OF_SALE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_13,currVal_13))) {
      this.renderer.setElementAttribute(this._el_0,'filter-tag',((currVal_13 == null)? (null as any): currVal_13.toString()));
      this._expr_13 = currVal_13;
    }
    valUnwrapper.reset();
    const currVal_15:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingList.filter.POINT_OF_SALE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_15,currVal_15))) {
      this.renderer.setElementProperty(this._el_0,'label',currVal_15);
      this._expr_15 = currVal_15;
    }
    const currVal_17:any = 'md';
    if (import3.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementProperty(this._el_0,'size',currVal_17);
      this._expr_17 = currVal_17;
    }
    const currVal_18:any = 'Campo invalido!';
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementProperty(this._el_0,'invalid-text',currVal_18);
      this._expr_18 = currVal_18;
    }
    const currVal_19:any = 'top left';
    if (import3.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementProperty(this._el_0,'invalid-position',currVal_19);
      this._expr_19 = currVal_19;
    }
    valUnwrapper.reset();
    const currVal_20:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('common.SELECT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_20,currVal_20))) {
      this.renderer.setText(this._text_3,currVal_20);
      this._expr_20 = currVal_20;
    }
  }
  dirtyParentQueriesInternal():void {
    (<View_BookingFilterComponent0>this.parentView)._viewQuery_pointOfSale_7.setDirty();
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._NgSelectOption_2_3.ngOnDestroy();
    this._NgSelectMultipleOption_2_4.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_BookingFilterComponent6(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
}
class View_BookingFilterComponent8 extends import2.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import13.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import14.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  _pipe_translate_0:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_BookingFilterComponent8,renderType_BookingFilterComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',new import3.InlineArray2(2,'class','select-option'),(null as any));
    this._NgSelectOption_0_3 = new import13.Wrapper_NgSelectOption(new import17.ElementRef(this._el_0),this.renderer,(null as any));
    this._NgSelectMultipleOption_0_4 = new import14.Wrapper_NgSelectMultipleOption(new import17.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import19.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = import3.inlineInterpolate(1,'',this.context.$implicit.text,'');
    this._NgSelectOption_0_3.check_value(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = import3.inlineInterpolate(1,'',this.context.$implicit.text,'');
    this._NgSelectMultipleOption_0_4.check_value(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.context.$implicit.value)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingFilterComponent7 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgSelectOption_2_3:import13.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_2_4:import14.Wrapper_NgSelectMultipleOption;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import16.ViewContainer;
  _TemplateRef_5_5:any;
  _NgFor_5_6:import24.Wrapper_NgFor;
  _text_6:any;
  /*private*/ _expr_12:any;
  _pipe_translate_0:import15.TranslatePipe;
  /*private*/ _expr_14:any;
  _pipe_translate_1:import15.TranslatePipe;
  /*private*/ _expr_16:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  _pipe_translate_2:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_BookingFilterComponent7,renderType_BookingFilterComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_12 = import1.UNINITIALIZED;
    this._expr_14 = import1.UNINITIALIZED;
    this._expr_16 = import1.UNINITIALIZED;
    this._expr_17 = import1.UNINITIALIZED;
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-select',new import3.InlineArray8(6,'filter-id','paymentMethod','id','paymentMethod','name','Forma de pago'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'option',new import3.InlineArray8(6,'disabled','','selected','','value',''),(null as any));
    this._NgSelectOption_2_3 = new import13.Wrapper_NgSelectOption(new import17.ElementRef(this._el_2),this.renderer,(null as any));
    this._NgSelectMultipleOption_2_4 = new import14.Wrapper_NgSelectMultipleOption(new import17.ElementRef(this._el_2),this.renderer,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_5 = new import16.ViewContainer(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import25.TemplateRef_(this,5,this._anchor_5);
    this._NgFor_5_6 = new import24.Wrapper_NgFor(this._vc_5.vcRef,this._TemplateRef_5_5,this.parentView.parentView.injectorGet(import26.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_6 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_2 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgSelectOption) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._NgSelectOption_2_3.context; }
    if (((token === import19.NgSelectMultipleOption) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._NgSelectMultipleOption_2_4.context; }
    if (((token === import25.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import27.NgFor) && (5 === requestNodeIndex))) { return this._NgFor_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_2_0_0:any = '';
    this._NgSelectOption_2_3.check_value(currVal_2_0_0,throwOnChange,false);
    this._NgSelectOption_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_2_1_0:any = '';
    this._NgSelectMultipleOption_2_4.check_value(currVal_2_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_2_4.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_5_0_0:any = this.parentView.context.data.paymentMethod;
    this._NgFor_5_6.check_ngForOf(currVal_5_0_0,throwOnChange,false);
    this._NgFor_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_12:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingList.filter.PAYMENT_METHOD')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_12,currVal_12))) {
      this.renderer.setElementAttribute(this._el_0,'filter-tag',((currVal_12 == null)? (null as any): currVal_12.toString()));
      this._expr_12 = currVal_12;
    }
    valUnwrapper.reset();
    const currVal_14:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingList.filter.PAYMENT_METHOD')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_14,currVal_14))) {
      this.renderer.setElementProperty(this._el_0,'label',currVal_14);
      this._expr_14 = currVal_14;
    }
    const currVal_16:any = 'md';
    if (import3.checkBinding(throwOnChange,this._expr_16,currVal_16)) {
      this.renderer.setElementProperty(this._el_0,'size',currVal_16);
      this._expr_16 = currVal_16;
    }
    const currVal_17:any = 'Campo invalido!';
    if (import3.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementProperty(this._el_0,'invalid-text',currVal_17);
      this._expr_17 = currVal_17;
    }
    const currVal_18:any = 'top left';
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementProperty(this._el_0,'invalid-position',currVal_18);
      this._expr_18 = currVal_18;
    }
    valUnwrapper.reset();
    const currVal_19:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('common.SELECT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_19,currVal_19))) {
      this.renderer.setText(this._text_3,currVal_19);
      this._expr_19 = currVal_19;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._NgSelectOption_2_3.ngOnDestroy();
    this._NgSelectMultipleOption_2_4.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_BookingFilterComponent8(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
}
class View_BookingFilterComponent9 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  /*private*/ _expr_7:any;
  /*private*/ _expr_8:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_BookingFilterComponent9,renderType_BookingFilterComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_7 = import1.UNINITIALIZED;
    this._expr_8 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-autocomplete-item',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'i',new import3.InlineArray2(2,'class','eva-3-icon-cars'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_7:any = import3.inlineInterpolate(1,'',this.context.$implicit.oid,'');
    if (import3.checkBinding(throwOnChange,this._expr_7,currVal_7)) {
      this.renderer.setElementProperty(this._el_0,'value',currVal_7);
      this._expr_7 = currVal_7;
    }
    const currVal_8:any = import3.inlineInterpolate(1,'',this.context.$implicit.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_8,currVal_8)) {
      this.renderer.setText(this._text_5,currVal_8);
      this._expr_8 = currVal_8;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingFilterComponent10 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  /*private*/ _expr_7:any;
  /*private*/ _expr_8:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_BookingFilterComponent10,renderType_BookingFilterComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_7 = import1.UNINITIALIZED;
    this._expr_8 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-autocomplete-item',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'i',new import3.InlineArray2(2,'class','eva-3-icon-cars'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_7:any = import3.inlineInterpolate(1,'',this.context.$implicit.oid,'');
    if (import3.checkBinding(throwOnChange,this._expr_7,currVal_7)) {
      this.renderer.setElementProperty(this._el_0,'value',currVal_7);
      this._expr_7 = currVal_7;
    }
    const currVal_8:any = import3.inlineInterpolate(1,'',this.context.$implicit.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_8,currVal_8)) {
      this.renderer.setText(this._text_5,currVal_8);
      this._expr_8 = currVal_8;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingFilterComponent12 extends import2.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import13.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import14.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_BookingFilterComponent12,renderType_BookingFilterComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',new import3.InlineArray2(2,'class','select-option'),(null as any));
    this._NgSelectOption_0_3 = new import13.Wrapper_NgSelectOption(new import17.ElementRef(this._el_0),this.renderer,(null as any));
    this._NgSelectMultipleOption_0_4 = new import14.Wrapper_NgSelectMultipleOption(new import17.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import19.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = import3.inlineInterpolate(1,'',this.context.$implicit.code,'');
    this._NgSelectOption_0_3.check_value(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = import3.inlineInterpolate(1,'',this.context.$implicit.code,'');
    this._NgSelectMultipleOption_0_4.check_value(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_4:any = import3.inlineInterpolate(1,'',this.context.$implicit.description,'');
    if (import3.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingFilterComponent11 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgSelectOption_2_3:import13.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_2_4:import14.Wrapper_NgSelectMultipleOption;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import16.ViewContainer;
  _TemplateRef_5_5:any;
  _NgFor_5_6:import24.Wrapper_NgFor;
  _text_6:any;
  /*private*/ _expr_12:any;
  _pipe_translate_0:import15.TranslatePipe;
  /*private*/ _expr_14:any;
  _pipe_translate_1:import15.TranslatePipe;
  /*private*/ _expr_16:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  _pipe_translate_2:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_BookingFilterComponent11,renderType_BookingFilterComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_12 = import1.UNINITIALIZED;
    this._expr_14 = import1.UNINITIALIZED;
    this._expr_16 = import1.UNINITIALIZED;
    this._expr_17 = import1.UNINITIALIZED;
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-select',new import3.InlineArray8(6,'filter-id','brand','id','brand','name','Lugar de compra'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'option',new import3.InlineArray8(6,'disabled','','selected','','value',''),(null as any));
    this._NgSelectOption_2_3 = new import13.Wrapper_NgSelectOption(new import17.ElementRef(this._el_2),this.renderer,(null as any));
    this._NgSelectMultipleOption_2_4 = new import14.Wrapper_NgSelectMultipleOption(new import17.ElementRef(this._el_2),this.renderer,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_5 = new import16.ViewContainer(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import25.TemplateRef_(this,5,this._anchor_5);
    this._NgFor_5_6 = new import24.Wrapper_NgFor(this._vc_5.vcRef,this._TemplateRef_5_5,this.parentView.parentView.injectorGet(import26.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_6 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_2 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgSelectOption) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._NgSelectOption_2_3.context; }
    if (((token === import19.NgSelectMultipleOption) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._NgSelectMultipleOption_2_4.context; }
    if (((token === import25.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import27.NgFor) && (5 === requestNodeIndex))) { return this._NgFor_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_2_0_0:any = '';
    this._NgSelectOption_2_3.check_value(currVal_2_0_0,throwOnChange,false);
    this._NgSelectOption_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_2_1_0:any = '';
    this._NgSelectMultipleOption_2_4.check_value(currVal_2_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_2_4.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_5_0_0:any = this.parentView.context.data.placeOfPurchase;
    this._NgFor_5_6.check_ngForOf(currVal_5_0_0,throwOnChange,false);
    this._NgFor_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_12:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingList.SEARCH_COUNTRY_NAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_12,currVal_12))) {
      this.renderer.setElementAttribute(this._el_0,'filter-tag',((currVal_12 == null)? (null as any): currVal_12.toString()));
      this._expr_12 = currVal_12;
    }
    valUnwrapper.reset();
    const currVal_14:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingList.SEARCH_COUNTRY_NAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_14,currVal_14))) {
      this.renderer.setElementProperty(this._el_0,'label',currVal_14);
      this._expr_14 = currVal_14;
    }
    const currVal_16:any = 'md';
    if (import3.checkBinding(throwOnChange,this._expr_16,currVal_16)) {
      this.renderer.setElementProperty(this._el_0,'size',currVal_16);
      this._expr_16 = currVal_16;
    }
    const currVal_17:any = 'Campo invalido!';
    if (import3.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementProperty(this._el_0,'invalid-text',currVal_17);
      this._expr_17 = currVal_17;
    }
    const currVal_18:any = 'top left';
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementProperty(this._el_0,'invalid-position',currVal_18);
      this._expr_18 = currVal_18;
    }
    valUnwrapper.reset();
    const currVal_19:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('common.SELECT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_19,currVal_19))) {
      this.renderer.setText(this._text_3,currVal_19);
      this._expr_19 = currVal_19;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._NgSelectOption_2_3.ngOnDestroy();
    this._NgSelectMultipleOption_2_4.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_BookingFilterComponent12(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
}
class View_BookingFilterComponent13 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  /*private*/ _expr_7:any;
  /*private*/ _expr_8:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_BookingFilterComponent13,renderType_BookingFilterComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_7 = import1.UNINITIALIZED;
    this._expr_8 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-autocomplete-item',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'i',new import3.InlineArray2(2,'class','eva-3-icon-cars'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_7:any = import3.inlineInterpolate(1,'',this.context.$implicit.oid,'');
    if (import3.checkBinding(throwOnChange,this._expr_7,currVal_7)) {
      this.renderer.setElementProperty(this._el_0,'value',currVal_7);
      this._expr_7 = currVal_7;
    }
    const currVal_8:any = import3.inlineInterpolate(1,'',this.context.$implicit.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_8,currVal_8)) {
      this.renderer.setText(this._text_5,currVal_8);
      this._expr_8 = currVal_8;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_BookingFilterComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_BookingFilterComponent,{});
export class View_BookingFilterComponent0 extends import2.AppView<import0.BookingFilterComponent> {
  _viewQuery_companyName_0:import34.QueryList<any>;
  _viewQuery_rangeType_1:import34.QueryList<any>;
  _viewQuery_selectDateRange_2:import34.QueryList<any>;
  _viewQuery_testCheck_3:import34.QueryList<any>;
  _viewQuery_companyOid_4:import34.QueryList<any>;
  _viewQuery_pickupCity_5:import34.QueryList<any>;
  _viewQuery_dropoffCity_6:import34.QueryList<any>;
  _viewQuery_pointOfSale_7:import34.QueryList<any>;
  _viewQuery_bookingOid_8:import34.QueryList<any>;
  _viewQuery_fenixOid_9:import34.QueryList<any>;
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _anchor_12:any;
  /*private*/ _vc_12:import16.ViewContainer;
  _TemplateRef_12_5:any;
  _NgIf_12_6:import35.Wrapper_NgIf;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _DefaultValueAccessor_20_3:import20.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_20_4:any[];
  _NgModel_20_5:import21.Wrapper_NgModel;
  _NgControl_20_6:any;
  _NgControlStatus_20_7:import22.Wrapper_NgControlStatus;
  _NgModelWc_20_8:import23.Wrapper_NgModelWc;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _el_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _el_29:any;
  _text_30:any;
  _text_31:any;
  _text_32:any;
  _text_33:any;
  _text_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _el_38:any;
  _DefaultValueAccessor_38_3:import20.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_38_4:any[];
  _NgModel_38_5:import21.Wrapper_NgModel;
  _NgControl_38_6:any;
  _NgControlStatus_38_7:import22.Wrapper_NgControlStatus;
  _NgModelWc_38_8:import23.Wrapper_NgModelWc;
  _text_39:any;
  _text_40:any;
  _text_41:any;
  _el_42:any;
  _DefaultValueAccessor_42_3:import20.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_42_4:any[];
  _NgModel_42_5:import21.Wrapper_NgModel;
  _NgControl_42_6:any;
  _NgControlStatus_42_7:import22.Wrapper_NgControlStatus;
  _NgModelWc_42_8:import23.Wrapper_NgModelWc;
  _text_43:any;
  _text_44:any;
  _el_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _anchor_51:any;
  /*private*/ _vc_51:import16.ViewContainer;
  _TemplateRef_51_5:any;
  _NgIf_51_6:import35.Wrapper_NgIf;
  _text_52:any;
  _text_53:any;
  _text_54:any;
  _el_55:any;
  _text_56:any;
  _el_57:any;
  _text_58:any;
  _el_59:any;
  _text_60:any;
  _text_61:any;
  _el_62:any;
  _text_63:any;
  _el_64:any;
  _text_65:any;
  _text_66:any;
  _text_67:any;
  _text_68:any;
  _el_69:any;
  _text_70:any;
  _el_71:any;
  _text_72:any;
  _el_73:any;
  _text_74:any;
  _text_75:any;
  _el_76:any;
  _text_77:any;
  _el_78:any;
  _text_79:any;
  _text_80:any;
  _text_81:any;
  _text_82:any;
  _el_83:any;
  _text_84:any;
  _el_85:any;
  _text_86:any;
  _el_87:any;
  _text_88:any;
  _el_89:any;
  _text_90:any;
  _anchor_91:any;
  /*private*/ _vc_91:import16.ViewContainer;
  _TemplateRef_91_5:any;
  _NgIf_91_6:import35.Wrapper_NgIf;
  _text_92:any;
  _text_93:any;
  _text_94:any;
  _text_95:any;
  _el_96:any;
  _text_97:any;
  _el_98:any;
  _text_99:any;
  _el_100:any;
  _text_101:any;
  _anchor_102:any;
  /*private*/ _vc_102:import16.ViewContainer;
  _TemplateRef_102_5:any;
  _NgIf_102_6:import35.Wrapper_NgIf;
  _text_103:any;
  _text_104:any;
  _text_105:any;
  _text_106:any;
  _el_107:any;
  _text_108:any;
  _el_109:any;
  _text_110:any;
  _el_111:any;
  _text_112:any;
  _text_113:any;
  _text_114:any;
  _text_115:any;
  _el_116:any;
  _text_117:any;
  _el_118:any;
  _text_119:any;
  _el_120:any;
  _text_121:any;
  _el_122:any;
  _text_123:any;
  _el_124:any;
  _text_125:any;
  _el_126:any;
  _text_127:any;
  _el_128:any;
  _text_129:any;
  _text_130:any;
  _text_131:any;
  _anchor_132:any;
  /*private*/ _vc_132:import16.ViewContainer;
  _TemplateRef_132_5:any;
  _NgFor_132_6:import24.Wrapper_NgFor;
  _text_133:any;
  _text_134:any;
  _text_135:any;
  _text_136:any;
  _el_137:any;
  _text_138:any;
  _el_139:any;
  _text_140:any;
  _el_141:any;
  _text_142:any;
  _el_143:any;
  _text_144:any;
  _el_145:any;
  _text_146:any;
  _el_147:any;
  _text_148:any;
  _text_149:any;
  _text_150:any;
  _anchor_151:any;
  /*private*/ _vc_151:import16.ViewContainer;
  _TemplateRef_151_5:any;
  _NgFor_151_6:import24.Wrapper_NgFor;
  _text_152:any;
  _text_153:any;
  _text_154:any;
  _text_155:any;
  _el_156:any;
  _text_157:any;
  _el_158:any;
  _text_159:any;
  _anchor_160:any;
  /*private*/ _vc_160:import16.ViewContainer;
  _TemplateRef_160_5:any;
  _NgIf_160_6:import35.Wrapper_NgIf;
  _text_161:any;
  _text_162:any;
  _text_163:any;
  _text_164:any;
  _el_165:any;
  _NgClass_165_3:import36.Wrapper_NgClass;
  _text_166:any;
  _el_167:any;
  _text_168:any;
  _el_169:any;
  _text_170:any;
  _el_171:any;
  _text_172:any;
  _el_173:any;
  _text_174:any;
  _el_175:any;
  _text_176:any;
  _el_177:any;
  _text_178:any;
  _text_179:any;
  _text_180:any;
  _anchor_181:any;
  /*private*/ _vc_181:import16.ViewContainer;
  _TemplateRef_181_5:any;
  _NgFor_181_6:import24.Wrapper_NgFor;
  _text_182:any;
  _text_183:any;
  _text_184:any;
  _text_185:any;
  _el_186:any;
  _text_187:any;
  _el_188:any;
  _text_189:any;
  _el_190:any;
  _text_191:any;
  _text_192:any;
  _text_193:any;
  _el_194:any;
  _text_195:any;
  _el_196:any;
  _text_197:any;
  _el_198:any;
  _text_199:any;
  _text_200:any;
  _text_201:any;
  _text_202:any;
  _text_203:any;
  _text_204:any;
  /*private*/ _expr_258:any;
  _pipe_translate_0:import15.TranslatePipe;
  /*private*/ _expr_260:any;
  _pipe_translate_1:import15.TranslatePipe;
  /*private*/ _expr_262:any;
  _pipe_translate_2:import15.TranslatePipe;
  /*private*/ _expr_264:any;
  _pipe_translate_3:import15.TranslatePipe;
  /*private*/ _expr_266:any;
  _pipe_translate_4:import15.TranslatePipe;
  /*private*/ _expr_268:any;
  /*private*/ _expr_269:any;
  /*private*/ _expr_270:any;
  _pipe_translate_5:import15.TranslatePipe;
  /*private*/ _expr_272:any;
  _pipe_translate_6:import15.TranslatePipe;
  /*private*/ _expr_274:any;
  /*private*/ _expr_275:any;
  /*private*/ _expr_276:any;
  _pipe_translate_7:import15.TranslatePipe;
  /*private*/ _expr_278:any;
  /*private*/ _expr_279:any;
  _pipe_translate_8:import15.TranslatePipe;
  /*private*/ _expr_281:any;
  /*private*/ _expr_282:any;
  /*private*/ _expr_283:any;
  _pipe_translate_9:import15.TranslatePipe;
  /*private*/ _expr_285:any;
  _pipe_translate_10:import15.TranslatePipe;
  /*private*/ _expr_287:any;
  _pipe_translate_11:import15.TranslatePipe;
  /*private*/ _expr_289:any;
  _pipe_translate_12:import15.TranslatePipe;
  /*private*/ _expr_291:any;
  /*private*/ _expr_292:any;
  /*private*/ _expr_293:any;
  /*private*/ _expr_294:any;
  _pipe_translate_13:import15.TranslatePipe;
  /*private*/ _expr_296:any;
  _pipe_translate_14:import15.TranslatePipe;
  /*private*/ _expr_298:any;
  _pipe_translate_15:import15.TranslatePipe;
  /*private*/ _expr_300:any;
  /*private*/ _expr_301:any;
  /*private*/ _expr_302:any;
  /*private*/ _expr_303:any;
  _pipe_translate_16:import15.TranslatePipe;
  /*private*/ _expr_305:any;
  _pipe_translate_17:import15.TranslatePipe;
  /*private*/ _expr_307:any;
  _pipe_translate_18:import15.TranslatePipe;
  /*private*/ _expr_309:any;
  /*private*/ _expr_310:any;
  /*private*/ _expr_311:any;
  /*private*/ _expr_312:any;
  _pipe_translate_19:import15.TranslatePipe;
  /*private*/ _expr_314:any;
  _pipe_translate_20:import15.TranslatePipe;
  /*private*/ _expr_316:any;
  _pipe_translate_21:import15.TranslatePipe;
  /*private*/ _expr_318:any;
  /*private*/ _expr_319:any;
  /*private*/ _expr_320:any;
  /*private*/ _expr_321:any;
  _pipe_translate_22:import15.TranslatePipe;
  /*private*/ _expr_323:any;
  _pipe_translate_23:import15.TranslatePipe;
  /*private*/ _expr_325:any;
  _pipe_translate_24:import15.TranslatePipe;
  /*private*/ _expr_327:any;
  /*private*/ _expr_328:any;
  /*private*/ _expr_329:any;
  /*private*/ _expr_330:any;
  _pipe_translate_25:import15.TranslatePipe;
  /*private*/ _expr_332:any;
  _pipe_translate_26:import15.TranslatePipe;
  /*private*/ _expr_334:any;
  _pipe_translate_27:import15.TranslatePipe;
  /*private*/ _expr_336:any;
  _pipe_translate_28:import15.TranslatePipe;
  /*private*/ _expr_338:any;
  _pipe_translate_29:import15.TranslatePipe;
  /*private*/ _expr_340:any;
  _pipe_translate_30:import15.TranslatePipe;
  /*private*/ _expr_342:any;
  _pipe_translate_31:import15.TranslatePipe;
  /*private*/ _expr_344:any;
  _pipe_translate_32:import15.TranslatePipe;
  _map_346:any;
  /*private*/ _expr_347:any;
  /*private*/ _expr_348:any;
  _pipe_translate_33:import15.TranslatePipe;
  /*private*/ _expr_350:any;
  _pipe_translate_34:import15.TranslatePipe;
  /*private*/ _expr_352:any;
  _pipe_translate_35:import15.TranslatePipe;
  /*private*/ _expr_354:any;
  _pipe_translate_36:import15.TranslatePipe;
  /*private*/ _expr_356:any;
  /*private*/ _expr_357:any;
  _pipe_translate_37:import15.TranslatePipe;
  /*private*/ _expr_359:any;
  _pipe_translate_38:import15.TranslatePipe;
  /*private*/ _expr_361:any;
  _pipe_translate_39:import15.TranslatePipe;
  /*private*/ _expr_363:any;
  /*private*/ _expr_364:any;
  /*private*/ _expr_365:any;
  /*private*/ _expr_366:any;
  /*private*/ _expr_367:any;
  /*private*/ _expr_368:any;
  _pipe_translate_40:import15.TranslatePipe;
  /*private*/ _expr_370:any;
  _pipe_translate_41:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_BookingFilterComponent0,renderType_BookingFilterComponent,import8.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
    this._expr_258 = import1.UNINITIALIZED;
    this._expr_260 = import1.UNINITIALIZED;
    this._expr_262 = import1.UNINITIALIZED;
    this._expr_264 = import1.UNINITIALIZED;
    this._expr_266 = import1.UNINITIALIZED;
    this._expr_268 = import1.UNINITIALIZED;
    this._expr_269 = import1.UNINITIALIZED;
    this._expr_270 = import1.UNINITIALIZED;
    this._expr_272 = import1.UNINITIALIZED;
    this._expr_274 = import1.UNINITIALIZED;
    this._expr_275 = import1.UNINITIALIZED;
    this._expr_276 = import1.UNINITIALIZED;
    this._expr_278 = import1.UNINITIALIZED;
    this._expr_279 = import1.UNINITIALIZED;
    this._expr_281 = import1.UNINITIALIZED;
    this._expr_282 = import1.UNINITIALIZED;
    this._expr_283 = import1.UNINITIALIZED;
    this._expr_285 = import1.UNINITIALIZED;
    this._expr_287 = import1.UNINITIALIZED;
    this._expr_289 = import1.UNINITIALIZED;
    this._expr_291 = import1.UNINITIALIZED;
    this._expr_292 = import1.UNINITIALIZED;
    this._expr_293 = import1.UNINITIALIZED;
    this._expr_294 = import1.UNINITIALIZED;
    this._expr_296 = import1.UNINITIALIZED;
    this._expr_298 = import1.UNINITIALIZED;
    this._expr_300 = import1.UNINITIALIZED;
    this._expr_301 = import1.UNINITIALIZED;
    this._expr_302 = import1.UNINITIALIZED;
    this._expr_303 = import1.UNINITIALIZED;
    this._expr_305 = import1.UNINITIALIZED;
    this._expr_307 = import1.UNINITIALIZED;
    this._expr_309 = import1.UNINITIALIZED;
    this._expr_310 = import1.UNINITIALIZED;
    this._expr_311 = import1.UNINITIALIZED;
    this._expr_312 = import1.UNINITIALIZED;
    this._expr_314 = import1.UNINITIALIZED;
    this._expr_316 = import1.UNINITIALIZED;
    this._expr_318 = import1.UNINITIALIZED;
    this._expr_319 = import1.UNINITIALIZED;
    this._expr_320 = import1.UNINITIALIZED;
    this._expr_321 = import1.UNINITIALIZED;
    this._expr_323 = import1.UNINITIALIZED;
    this._expr_325 = import1.UNINITIALIZED;
    this._expr_327 = import1.UNINITIALIZED;
    this._expr_328 = import1.UNINITIALIZED;
    this._expr_329 = import1.UNINITIALIZED;
    this._expr_330 = import1.UNINITIALIZED;
    this._expr_332 = import1.UNINITIALIZED;
    this._expr_334 = import1.UNINITIALIZED;
    this._expr_336 = import1.UNINITIALIZED;
    this._expr_338 = import1.UNINITIALIZED;
    this._expr_340 = import1.UNINITIALIZED;
    this._expr_342 = import1.UNINITIALIZED;
    this._expr_344 = import1.UNINITIALIZED;
    this._map_346 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'hide-filters-despegar': p0};
    });
    this._expr_347 = import1.UNINITIALIZED;
    this._expr_348 = import1.UNINITIALIZED;
    this._expr_350 = import1.UNINITIALIZED;
    this._expr_352 = import1.UNINITIALIZED;
    this._expr_354 = import1.UNINITIALIZED;
    this._expr_356 = import1.UNINITIALIZED;
    this._expr_357 = import1.UNINITIALIZED;
    this._expr_359 = import1.UNINITIALIZED;
    this._expr_361 = import1.UNINITIALIZED;
    this._expr_363 = import1.UNINITIALIZED;
    this._expr_364 = import1.UNINITIALIZED;
    this._expr_365 = import1.UNINITIALIZED;
    this._expr_366 = import1.UNINITIALIZED;
    this._expr_367 = import1.UNINITIALIZED;
    this._expr_368 = import1.UNINITIALIZED;
    this._expr_370 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_companyName_0 = new import34.QueryList<any>();
    this._viewQuery_rangeType_1 = new import34.QueryList<any>();
    this._viewQuery_selectDateRange_2 = new import34.QueryList<any>();
    this._viewQuery_testCheck_3 = new import34.QueryList<any>();
    this._viewQuery_companyOid_4 = new import34.QueryList<any>();
    this._viewQuery_pickupCity_5 = new import34.QueryList<any>();
    this._viewQuery_dropoffCity_6 = new import34.QueryList<any>();
    this._viewQuery_pointOfSale_7 = new import34.QueryList<any>();
    this._viewQuery_bookingOid_8 = new import34.QueryList<any>();
    this._viewQuery_fenixOid_9 = new import34.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-lg'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'dsp-filters-horizontal',new import3.InlineArray2(2,'full-on','sm'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'slot','filters'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','col -sm-12'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._anchor_12 = this.renderer.createTemplateAnchor(this._el_10,(null as any));
    this._vc_12 = new import16.ViewContainer(12,10,this,this._anchor_12);
    this._TemplateRef_12_5 = new import25.TemplateRef_(this,12,this._anchor_12);
    this._NgIf_12_6 = new import35.Wrapper_NgIf(this._vc_12.vcRef,this._TemplateRef_12_5);
    this._text_13 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_14 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_15 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n                    ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_16,'div',new import3.InlineArray2(2,'class','col -sm-6'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n                        ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_18,'dsp-datepicker',new import3.InlineArray16(16,'bound','start','bound-name','rangeDate','class','-eva-3-pr-sm','icon','true','id','from','name','Desde','ngDefaultControl','','readonly','true'),(null as any));
    this._DefaultValueAccessor_20_3 = new import20.Wrapper_DefaultValueAccessor(this.renderer,new import17.ElementRef(this._el_20));
    this._NG_VALUE_ACCESSOR_20_4 = [this._DefaultValueAccessor_20_3.context];
    this._NgModel_20_5 = new import21.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_20_4);
    this._NgControl_20_6 = this._NgModel_20_5.context;
    this._NgControlStatus_20_7 = new import22.Wrapper_NgControlStatus(this._NgControl_20_6);
    this._NgModelWc_20_8 = new import23.Wrapper_NgModelWc(new import17.ElementRef(this._el_20),this._NgModel_20_5.context);
    this._text_21 = this.renderer.createText(this._el_18,'\n                        ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_18,'span',new import3.InlineArray2(2,'class','eva-3-tooltip -bottom -right tooltip-booking-list -show-tooltip -eva-3-fr'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n                            ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_22,'span',new import3.InlineArray4(4,'class','tooltip-container','style','margin-left: -150px;'),(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_24,'i',new import3.InlineArray2(2,'class','tooltip-marker'),(null as any));
    this._text_26 = this.renderer.createText(this._el_24,'\n                                ',(null as any));
    this._el_27 = import3.createRenderElement(this.renderer,this._el_24,'span',new import3.InlineArray2(2,'class','tooltip-content'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'\n                                    ',(null as any));
    this._el_29 = import3.createRenderElement(this.renderer,this._el_27,'p',new import3.InlineArray2(2,'class','tooltip-text'),(null as any));
    this._text_30 = this.renderer.createText(this._el_29,'',(null as any));
    this._text_31 = this.renderer.createText(this._el_27,'\n                                ',(null as any));
    this._text_32 = this.renderer.createText(this._el_24,'\n                            ',(null as any));
    this._text_33 = this.renderer.createText(this._el_22,'\n                        ',(null as any));
    this._text_34 = this.renderer.createText(this._el_18,'\n                    ',(null as any));
    this._text_35 = this.renderer.createText(this._el_16,'\n                    ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_16,'div',new import3.InlineArray4(4,'class','col -sm-6','style','margin-top: 14.5px'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'\n                        ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_36,'dsp-datepicker',new import3.InlineArrayDynamic(20,'bound','end','bound-name','rangeDate','class','-eva-3-pl-sm','filter-id','period.to','icon','true','id','to','label',' ','name','Hasta','ngDefaultControl','','readonly','true'),(null as any));
    this._DefaultValueAccessor_38_3 = new import20.Wrapper_DefaultValueAccessor(this.renderer,new import17.ElementRef(this._el_38));
    this._NG_VALUE_ACCESSOR_38_4 = [this._DefaultValueAccessor_38_3.context];
    this._NgModel_38_5 = new import21.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_38_4);
    this._NgControl_38_6 = this._NgModel_38_5.context;
    this._NgControlStatus_38_7 = new import22.Wrapper_NgControlStatus(this._NgControl_38_6);
    this._NgModelWc_38_8 = new import23.Wrapper_NgModelWc(new import17.ElementRef(this._el_38),this._NgModel_38_5.context);
    this._text_39 = this.renderer.createText(this._el_36,'\n                    ',(null as any));
    this._text_40 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_41 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_42 = import3.createRenderElement(this.renderer,this._el_6,'dsp-input',new import3.InlineArray8(6,'name','Tipo de fecha','ngDefaultControl','','type','hidden'),(null as any));
    this._DefaultValueAccessor_42_3 = new import20.Wrapper_DefaultValueAccessor(this.renderer,new import17.ElementRef(this._el_42));
    this._NG_VALUE_ACCESSOR_42_4 = [this._DefaultValueAccessor_42_3.context];
    this._NgModel_42_5 = new import21.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_42_4);
    this._NgControl_42_6 = this._NgModel_42_5.context;
    this._NgControlStatus_42_7 = new import22.Wrapper_NgControlStatus(this._NgControl_42_6);
    this._NgModelWc_42_8 = new import23.Wrapper_NgModelWc(new import17.ElementRef(this._el_42),this._NgModel_42_5.context);
    this._text_43 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_44 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_45 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -lg-4 -sm-12 -md-4'),(null as any));
    this._text_46 = this.renderer.createText(this._el_45,'\n                ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_45,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'\n                    ',(null as any));
    this._el_49 = import3.createRenderElement(this.renderer,this._el_47,'div',new import3.InlineArray2(2,'class','col -sm-12'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'\n                        ',(null as any));
    this._anchor_51 = this.renderer.createTemplateAnchor(this._el_49,(null as any));
    this._vc_51 = new import16.ViewContainer(51,49,this,this._anchor_51);
    this._TemplateRef_51_5 = new import25.TemplateRef_(this,51,this._anchor_51);
    this._NgIf_51_6 = new import35.Wrapper_NgIf(this._vc_51.vcRef,this._TemplateRef_51_5);
    this._text_52 = this.renderer.createText(this._el_49,'\n                    ',(null as any));
    this._text_53 = this.renderer.createText(this._el_47,'\n                ',(null as any));
    this._text_54 = this.renderer.createText(this._el_45,'\n                ',(null as any));
    this._el_55 = import3.createRenderElement(this.renderer,this._el_45,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_56 = this.renderer.createText(this._el_55,'\n                    ',(null as any));
    this._el_57 = import3.createRenderElement(this.renderer,this._el_55,'div',new import3.InlineArray2(2,'class','col -sm-6'),(null as any));
    this._text_58 = this.renderer.createText(this._el_57,'\n                        ',(null as any));
    this._el_59 = import3.createRenderElement(this.renderer,this._el_57,'dsp-input',new import3.InlineArray16(12,'class','-eva-3-pr-sm','filter-id','bookingOID','id','bookingOID','name','Id de reserva','pattern','[0-9]*','type','number'),(null as any));
    this._text_60 = this.renderer.createText(this._el_57,'\n                    ',(null as any));
    this._text_61 = this.renderer.createText(this._el_55,'\n                    ',(null as any));
    this._el_62 = import3.createRenderElement(this.renderer,this._el_55,'div',new import3.InlineArray2(2,'class','col -sm-6'),(null as any));
    this._text_63 = this.renderer.createText(this._el_62,'\n                        ',(null as any));
    this._el_64 = import3.createRenderElement(this.renderer,this._el_62,'dsp-input',new import3.InlineArray16(12,'class','-eva-3-pl-sm','filter-id','fenixOID','id','fenixOID','name','Id de fenix','pattern','[0-9]*','type','number'),(null as any));
    this._text_65 = this.renderer.createText(this._el_62,'\n                    ',(null as any));
    this._text_66 = this.renderer.createText(this._el_55,'\n                ',(null as any));
    this._text_67 = this.renderer.createText(this._el_45,'\n            ',(null as any));
    this._text_68 = this.renderer.createText(this._el_4,'\n\n            ',(null as any));
    this._el_69 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -lg-4 -sm-12 -md-4'),(null as any));
    this._text_70 = this.renderer.createText(this._el_69,'\n                ',(null as any));
    this._el_71 = import3.createRenderElement(this.renderer,this._el_69,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_72 = this.renderer.createText(this._el_71,'\n                    ',(null as any));
    this._el_73 = import3.createRenderElement(this.renderer,this._el_71,'dsp-input',new import3.InlineArray8(6,'filter-id','username','id','username','name','Nombre'),(null as any));
    this._text_74 = this.renderer.createText(this._el_71,'\n                ',(null as any));
    this._text_75 = this.renderer.createText(this._el_69,'\n                ',(null as any));
    this._el_76 = import3.createRenderElement(this.renderer,this._el_69,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_77 = this.renderer.createText(this._el_76,'\n                    ',(null as any));
    this._el_78 = import3.createRenderElement(this.renderer,this._el_76,'dsp-input',new import3.InlineArray8(6,'filter-id','lastname','id','lastname','name','Apellido'),(null as any));
    this._text_79 = this.renderer.createText(this._el_76,'\n                ',(null as any));
    this._text_80 = this.renderer.createText(this._el_69,'\n            ',(null as any));
    this._text_81 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_82 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_83 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray4(4,'class','hidden-filters default-filters','slot','hiddenFilters'),(null as any));
    this._text_84 = this.renderer.createText(this._el_83,'\n            ',(null as any));
    this._el_85 = import3.createRenderElement(this.renderer,this._el_83,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_86 = this.renderer.createText(this._el_85,'\n                ',(null as any));
    this._el_87 = import3.createRenderElement(this.renderer,this._el_85,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_88 = this.renderer.createText(this._el_87,'\n                    ',(null as any));
    this._el_89 = import3.createRenderElement(this.renderer,this._el_87,'div',new import3.InlineArray2(2,'class','col -sm-12'),(null as any));
    this._text_90 = this.renderer.createText(this._el_89,'\n                        ',(null as any));
    this._anchor_91 = this.renderer.createTemplateAnchor(this._el_89,(null as any));
    this._vc_91 = new import16.ViewContainer(91,89,this,this._anchor_91);
    this._TemplateRef_91_5 = new import25.TemplateRef_(this,91,this._anchor_91);
    this._NgIf_91_6 = new import35.Wrapper_NgIf(this._vc_91.vcRef,this._TemplateRef_91_5);
    this._text_92 = this.renderer.createText(this._el_89,'\n                    ',(null as any));
    this._text_93 = this.renderer.createText(this._el_87,'\n                ',(null as any));
    this._text_94 = this.renderer.createText(this._el_85,'\n            ',(null as any));
    this._text_95 = this.renderer.createText(this._el_83,'\n            ',(null as any));
    this._el_96 = import3.createRenderElement(this.renderer,this._el_83,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_97 = this.renderer.createText(this._el_96,'\n                ',(null as any));
    this._el_98 = import3.createRenderElement(this.renderer,this._el_96,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_99 = this.renderer.createText(this._el_98,'\n                    ',(null as any));
    this._el_100 = import3.createRenderElement(this.renderer,this._el_98,'div',new import3.InlineArray2(2,'class','col -sm-12'),(null as any));
    this._text_101 = this.renderer.createText(this._el_100,'\n                        ',(null as any));
    this._anchor_102 = this.renderer.createTemplateAnchor(this._el_100,(null as any));
    this._vc_102 = new import16.ViewContainer(102,100,this,this._anchor_102);
    this._TemplateRef_102_5 = new import25.TemplateRef_(this,102,this._anchor_102);
    this._NgIf_102_6 = new import35.Wrapper_NgIf(this._vc_102.vcRef,this._TemplateRef_102_5);
    this._text_103 = this.renderer.createText(this._el_100,'\n                    ',(null as any));
    this._text_104 = this.renderer.createText(this._el_98,'\n                ',(null as any));
    this._text_105 = this.renderer.createText(this._el_96,'\n            ',(null as any));
    this._text_106 = this.renderer.createText(this._el_83,'\n            ',(null as any));
    this._el_107 = import3.createRenderElement(this.renderer,this._el_83,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_108 = this.renderer.createText(this._el_107,'\n                ',(null as any));
    this._el_109 = import3.createRenderElement(this.renderer,this._el_107,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_110 = this.renderer.createText(this._el_109,'\n                    ',(null as any));
    this._el_111 = import3.createRenderElement(this.renderer,this._el_109,'dsp-input',new import3.InlineArray4(4,'filter-id','email','name','Email'),(null as any));
    this._text_112 = this.renderer.createText(this._el_109,'\n                ',(null as any));
    this._text_113 = this.renderer.createText(this._el_107,'\n            ',(null as any));
    this._text_114 = this.renderer.createText(this._el_83,'\n        ',(null as any));
    this._text_115 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_116 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray4(4,'class','hidden-filters default-filters','slot','hiddenFilters'),(null as any));
    this._text_117 = this.renderer.createText(this._el_116,'\n            ',(null as any));
    this._el_118 = import3.createRenderElement(this.renderer,this._el_116,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_119 = this.renderer.createText(this._el_118,'\n                ',(null as any));
    this._el_120 = import3.createRenderElement(this.renderer,this._el_118,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_121 = this.renderer.createText(this._el_120,'\n                    ',(null as any));
    this._el_122 = import3.createRenderElement(this.renderer,this._el_120,'dsp-autocomplete',new import3.InlineArray8(6,'filter-id','pickupCityOID','id','pickupCity','name','Ciudad Pick Up'),(null as any));
    this._text_123 = this.renderer.createText(this._el_122,'\n                        ',(null as any));
    this._el_124 = import3.createRenderElement(this.renderer,this._el_122,'dsp-autocomplete-empty',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_125 = this.renderer.createText(this._el_124,'\n                            ',(null as any));
    this._el_126 = import3.createRenderElement(this.renderer,this._el_124,'i',new import3.InlineArray2(2,'class','eva-3-icon-search'),(null as any));
    this._text_127 = this.renderer.createText(this._el_124,'\n                            ',(null as any));
    this._el_128 = import3.createRenderElement(this.renderer,this._el_124,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_129 = this.renderer.createText(this._el_128,'',(null as any));
    this._text_130 = this.renderer.createText(this._el_124,'\n                        ',(null as any));
    this._text_131 = this.renderer.createText(this._el_122,'\n                        ',(null as any));
    this._anchor_132 = this.renderer.createTemplateAnchor(this._el_122,(null as any));
    this._vc_132 = new import16.ViewContainer(132,122,this,this._anchor_132);
    this._TemplateRef_132_5 = new import25.TemplateRef_(this,132,this._anchor_132);
    this._NgFor_132_6 = new import24.Wrapper_NgFor(this._vc_132.vcRef,this._TemplateRef_132_5,this.parentView.injectorGet(import26.IterableDiffers,this.parentIndex),this.ref);
    this._text_133 = this.renderer.createText(this._el_122,'\n                    ',(null as any));
    this._text_134 = this.renderer.createText(this._el_120,'\n                ',(null as any));
    this._text_135 = this.renderer.createText(this._el_118,'\n            ',(null as any));
    this._text_136 = this.renderer.createText(this._el_116,'\n            ',(null as any));
    this._el_137 = import3.createRenderElement(this.renderer,this._el_116,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_138 = this.renderer.createText(this._el_137,'\n                ',(null as any));
    this._el_139 = import3.createRenderElement(this.renderer,this._el_137,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_140 = this.renderer.createText(this._el_139,'\n                    ',(null as any));
    this._el_141 = import3.createRenderElement(this.renderer,this._el_139,'dsp-autocomplete',new import3.InlineArray8(6,'filter-id','dropoffCityOID','id','dropoffCity','name','Ciudad Drop Off'),(null as any));
    this._text_142 = this.renderer.createText(this._el_141,'\n                        ',(null as any));
    this._el_143 = import3.createRenderElement(this.renderer,this._el_141,'dsp-autocomplete-empty',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_144 = this.renderer.createText(this._el_143,'\n                            ',(null as any));
    this._el_145 = import3.createRenderElement(this.renderer,this._el_143,'i',new import3.InlineArray2(2,'class','eva-3-icon-search'),(null as any));
    this._text_146 = this.renderer.createText(this._el_143,'\n                            ',(null as any));
    this._el_147 = import3.createRenderElement(this.renderer,this._el_143,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_148 = this.renderer.createText(this._el_147,'',(null as any));
    this._text_149 = this.renderer.createText(this._el_143,'\n                        ',(null as any));
    this._text_150 = this.renderer.createText(this._el_141,'\n                        ',(null as any));
    this._anchor_151 = this.renderer.createTemplateAnchor(this._el_141,(null as any));
    this._vc_151 = new import16.ViewContainer(151,141,this,this._anchor_151);
    this._TemplateRef_151_5 = new import25.TemplateRef_(this,151,this._anchor_151);
    this._NgFor_151_6 = new import24.Wrapper_NgFor(this._vc_151.vcRef,this._TemplateRef_151_5,this.parentView.injectorGet(import26.IterableDiffers,this.parentIndex),this.ref);
    this._text_152 = this.renderer.createText(this._el_141,'\n                    ',(null as any));
    this._text_153 = this.renderer.createText(this._el_139,'\n                ',(null as any));
    this._text_154 = this.renderer.createText(this._el_137,'\n            ',(null as any));
    this._text_155 = this.renderer.createText(this._el_116,'\n            ',(null as any));
    this._el_156 = import3.createRenderElement(this.renderer,this._el_116,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_157 = this.renderer.createText(this._el_156,'\n                ',(null as any));
    this._el_158 = import3.createRenderElement(this.renderer,this._el_156,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_159 = this.renderer.createText(this._el_158,'\n                    ',(null as any));
    this._anchor_160 = this.renderer.createTemplateAnchor(this._el_158,(null as any));
    this._vc_160 = new import16.ViewContainer(160,158,this,this._anchor_160);
    this._TemplateRef_160_5 = new import25.TemplateRef_(this,160,this._anchor_160);
    this._NgIf_160_6 = new import35.Wrapper_NgIf(this._vc_160.vcRef,this._TemplateRef_160_5);
    this._text_161 = this.renderer.createText(this._el_158,'\n                ',(null as any));
    this._text_162 = this.renderer.createText(this._el_156,'\n            ',(null as any));
    this._text_163 = this.renderer.createText(this._el_116,'\n        ',(null as any));
    this._text_164 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_165 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray4(4,'class','hidden-filters despegar-filters','slot','hiddenFilters'),(null as any));
    this._NgClass_165_3 = new import36.Wrapper_NgClass(this.parentView.injectorGet(import26.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import37.KeyValueDiffers,this.parentIndex),new import17.ElementRef(this._el_165),this.renderer);
    this._text_166 = this.renderer.createText(this._el_165,'\n            ',(null as any));
    this._el_167 = import3.createRenderElement(this.renderer,this._el_165,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_168 = this.renderer.createText(this._el_167,'\n                ',(null as any));
    this._el_169 = import3.createRenderElement(this.renderer,this._el_167,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_170 = this.renderer.createText(this._el_169,'\n                    ',(null as any));
    this._el_171 = import3.createRenderElement(this.renderer,this._el_169,'dsp-autocomplete',new import3.InlineArray8(6,'filter-id','companyOID','id','companyName','name','Nombre rentadora'),(null as any));
    this._text_172 = this.renderer.createText(this._el_171,'\n                        ',(null as any));
    this._el_173 = import3.createRenderElement(this.renderer,this._el_171,'dsp-autocomplete-empty',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_174 = this.renderer.createText(this._el_173,'\n                            ',(null as any));
    this._el_175 = import3.createRenderElement(this.renderer,this._el_173,'i',new import3.InlineArray2(2,'class','eva-3-icon-search'),(null as any));
    this._text_176 = this.renderer.createText(this._el_173,'\n                            ',(null as any));
    this._el_177 = import3.createRenderElement(this.renderer,this._el_173,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_178 = this.renderer.createText(this._el_177,'',(null as any));
    this._text_179 = this.renderer.createText(this._el_173,'\n                        ',(null as any));
    this._text_180 = this.renderer.createText(this._el_171,'\n                        ',(null as any));
    this._anchor_181 = this.renderer.createTemplateAnchor(this._el_171,(null as any));
    this._vc_181 = new import16.ViewContainer(181,171,this,this._anchor_181);
    this._TemplateRef_181_5 = new import25.TemplateRef_(this,181,this._anchor_181);
    this._NgFor_181_6 = new import24.Wrapper_NgFor(this._vc_181.vcRef,this._TemplateRef_181_5,this.parentView.injectorGet(import26.IterableDiffers,this.parentIndex),this.ref);
    this._text_182 = this.renderer.createText(this._el_171,'\n                    ',(null as any));
    this._text_183 = this.renderer.createText(this._el_169,'\n                ',(null as any));
    this._text_184 = this.renderer.createText(this._el_167,'\n            ',(null as any));
    this._text_185 = this.renderer.createText(this._el_165,'\n            ',(null as any));
    this._el_186 = import3.createRenderElement(this.renderer,this._el_165,'div',new import3.InlineArray2(2,'class','col -lg-4 -sm-12 -md-4'),(null as any));
    this._text_187 = this.renderer.createText(this._el_186,'\n                ',(null as any));
    this._el_188 = import3.createRenderElement(this.renderer,this._el_186,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_189 = this.renderer.createText(this._el_188,'\n                    ',(null as any));
    this._el_190 = import3.createRenderElement(this.renderer,this._el_188,'dsp-input',new import3.InlineArray16(10,'filter-id','companyOID','id','companyOID','name','Id rentadora','pattern','[0-9]*','type','number'),(null as any));
    this._text_191 = this.renderer.createText(this._el_188,'\n                ',(null as any));
    this._text_192 = this.renderer.createText(this._el_186,'\n            ',(null as any));
    this._text_193 = this.renderer.createText(this._el_165,'\n            ',(null as any));
    this._el_194 = import3.createRenderElement(this.renderer,this._el_165,'div',new import3.InlineArray4(4,'class','col -lg-4 -sm-12 -md-4','style','margin-top: 20px;'),(null as any));
    this._text_195 = this.renderer.createText(this._el_194,'\n                ',(null as any));
    this._el_196 = import3.createRenderElement(this.renderer,this._el_194,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_197 = this.renderer.createText(this._el_196,'\n                    ',(null as any));
    this._el_198 = import3.createRenderElement(this.renderer,this._el_196,'dsp-checkbox',new import3.InlineArray4(4,'filter-id','test','name','Test'),(null as any));
    this._text_199 = this.renderer.createText(this._el_196,'\n                ',(null as any));
    this._text_200 = this.renderer.createText(this._el_194,'\n            ',(null as any));
    this._text_201 = this.renderer.createText(this._el_165,'\n        ',(null as any));
    this._text_202 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_203 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_204 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray8(8,'filtersApplied',(null as any),'filterRemoved',(null as any),'filtersRemoved',(null as any),'showAdvancedFilters',(null as any)),this.eventHandler(this.handleEvent_2));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_3 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_4 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_20,new import3.InlineArray8(8,'click',(null as any),'ngModelChange',(null as any),'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_20));
    this._NgModel_20_5.subscribe(this,this.eventHandler(this.handleEvent_20),true);
    this._NgModelWc_20_8.subscribe(this,this.eventHandler(this.handleEvent_20),true);
    this._pipe_translate_5 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_7 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_38,new import3.InlineArray16(10,'change',(null as any),'click',(null as any),'ngModelChange',(null as any),'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_38));
    this._NgModel_38_5.subscribe(this,this.eventHandler(this.handleEvent_38),true);
    this._NgModelWc_38_8.subscribe(this,this.eventHandler(this.handleEvent_38),true);
    this._pipe_translate_8 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_42,new import3.InlineArray8(6,'ngModelChange',(null as any),'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_42));
    this._NgModel_42_5.subscribe(this,this.eventHandler(this.handleEvent_42),true);
    this._NgModelWc_42_8.subscribe(this,this.eventHandler(this.handleEvent_42),true);
    this._pipe_translate_9 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_10 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_11 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_12 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_13 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_14 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_15 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_16 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_17 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_18 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_19 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_20 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_21 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_22 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_23 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_24 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    var disposable_4:Function = import3.subscribeToRenderElement(this,this._el_122,new import3.InlineArray2(2,'search',(null as any)),this.eventHandler(this.handleEvent_122));
    this._pipe_translate_25 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_26 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_27 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_28 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    var disposable_5:Function = import3.subscribeToRenderElement(this,this._el_141,new import3.InlineArray2(2,'search',(null as any)),this.eventHandler(this.handleEvent_141));
    this._pipe_translate_29 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_30 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_31 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_32 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    var disposable_6:Function = import3.subscribeToRenderElement(this,this._el_171,new import3.InlineArray4(4,'itemSelected',(null as any),'search',(null as any)),this.eventHandler(this.handleEvent_171));
    this._pipe_translate_33 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_34 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_35 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_36 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    var disposable_7:Function = import3.subscribeToRenderElement(this,this._el_190,new import3.InlineArray2(2,'focusout',(null as any)),this.eventHandler(this.handleEvent_190));
    this._pipe_translate_37 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_38 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_39 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    var disposable_8:Function = import3.subscribeToRenderElement(this,this._el_198,new import3.InlineArray2(2,'change',(null as any)),this.eventHandler(this.handleEvent_198));
    this._pipe_translate_40 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_41 = new import15.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._viewQuery_companyName_0.reset([new import17.ElementRef(this._el_171)]);
    this.context.companyName = this._viewQuery_companyName_0.first;
    this._viewQuery_rangeType_1.reset([new import17.ElementRef(this._el_42)]);
    this.context.rangeType = this._viewQuery_rangeType_1.first;
    this._viewQuery_testCheck_3.reset([new import17.ElementRef(this._el_198)]);
    this.context.testCheck = this._viewQuery_testCheck_3.first;
    this._viewQuery_companyOid_4.reset([new import17.ElementRef(this._el_190)]);
    this.context.companyOid = this._viewQuery_companyOid_4.first;
    this._viewQuery_pickupCity_5.reset([new import17.ElementRef(this._el_122)]);
    this.context.pickupCity = this._viewQuery_pickupCity_5.first;
    this._viewQuery_dropoffCity_6.reset([new import17.ElementRef(this._el_141)]);
    this.context.dropoffCity = this._viewQuery_dropoffCity_6.first;
    this._viewQuery_bookingOid_8.reset([new import17.ElementRef(this._el_59)]);
    this.context.bookingOid = this._viewQuery_bookingOid_8.first;
    this._viewQuery_fenixOid_9.reset([new import17.ElementRef(this._el_64)]);
    this.context.fenixOid = this._viewQuery_fenixOid_9.first;
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._anchor_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._el_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._el_29,
      this._text_30,
      this._text_31,
      this._text_32,
      this._text_33,
      this._text_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._text_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._anchor_51,
      this._text_52,
      this._text_53,
      this._text_54,
      this._el_55,
      this._text_56,
      this._el_57,
      this._text_58,
      this._el_59,
      this._text_60,
      this._text_61,
      this._el_62,
      this._text_63,
      this._el_64,
      this._text_65,
      this._text_66,
      this._text_67,
      this._text_68,
      this._el_69,
      this._text_70,
      this._el_71,
      this._text_72,
      this._el_73,
      this._text_74,
      this._text_75,
      this._el_76,
      this._text_77,
      this._el_78,
      this._text_79,
      this._text_80,
      this._text_81,
      this._text_82,
      this._el_83,
      this._text_84,
      this._el_85,
      this._text_86,
      this._el_87,
      this._text_88,
      this._el_89,
      this._text_90,
      this._anchor_91,
      this._text_92,
      this._text_93,
      this._text_94,
      this._text_95,
      this._el_96,
      this._text_97,
      this._el_98,
      this._text_99,
      this._el_100,
      this._text_101,
      this._anchor_102,
      this._text_103,
      this._text_104,
      this._text_105,
      this._text_106,
      this._el_107,
      this._text_108,
      this._el_109,
      this._text_110,
      this._el_111,
      this._text_112,
      this._text_113,
      this._text_114,
      this._text_115,
      this._el_116,
      this._text_117,
      this._el_118,
      this._text_119,
      this._el_120,
      this._text_121,
      this._el_122,
      this._text_123,
      this._el_124,
      this._text_125,
      this._el_126,
      this._text_127,
      this._el_128,
      this._text_129,
      this._text_130,
      this._text_131,
      this._anchor_132,
      this._text_133,
      this._text_134,
      this._text_135,
      this._text_136,
      this._el_137,
      this._text_138,
      this._el_139,
      this._text_140,
      this._el_141,
      this._text_142,
      this._el_143,
      this._text_144,
      this._el_145,
      this._text_146,
      this._el_147,
      this._text_148,
      this._text_149,
      this._text_150,
      this._anchor_151,
      this._text_152,
      this._text_153,
      this._text_154,
      this._text_155,
      this._el_156,
      this._text_157,
      this._el_158,
      this._text_159,
      this._anchor_160,
      this._text_161,
      this._text_162,
      this._text_163,
      this._text_164,
      this._el_165,
      this._text_166,
      this._el_167,
      this._text_168,
      this._el_169,
      this._text_170,
      this._el_171,
      this._text_172,
      this._el_173,
      this._text_174,
      this._el_175,
      this._text_176,
      this._el_177,
      this._text_178,
      this._text_179,
      this._text_180,
      this._anchor_181,
      this._text_182,
      this._text_183,
      this._text_184,
      this._text_185,
      this._el_186,
      this._text_187,
      this._el_188,
      this._text_189,
      this._el_190,
      this._text_191,
      this._text_192,
      this._text_193,
      this._el_194,
      this._text_195,
      this._el_196,
      this._text_197,
      this._el_198,
      this._text_199,
      this._text_200,
      this._text_201,
      this._text_202,
      this._text_203,
      this._text_204
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7,
      disposable_8
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.TemplateRef) && (12 === requestNodeIndex))) { return this._TemplateRef_12_5; }
    if (((token === import38.NgIf) && (12 === requestNodeIndex))) { return this._NgIf_12_6.context; }
    if (((token === import28.DefaultValueAccessor) && (20 === requestNodeIndex))) { return this._DefaultValueAccessor_20_3.context; }
    if (((token === import29.NG_VALUE_ACCESSOR) && (20 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_20_4; }
    if (((token === import30.NgModel) && (20 === requestNodeIndex))) { return this._NgModel_20_5.context; }
    if (((token === import31.NgControl) && (20 === requestNodeIndex))) { return this._NgControl_20_6; }
    if (((token === import32.NgControlStatus) && (20 === requestNodeIndex))) { return this._NgControlStatus_20_7.context; }
    if (((token === import33.NgModelWc) && (20 === requestNodeIndex))) { return this._NgModelWc_20_8.context; }
    if (((token === import28.DefaultValueAccessor) && (38 === requestNodeIndex))) { return this._DefaultValueAccessor_38_3.context; }
    if (((token === import29.NG_VALUE_ACCESSOR) && (38 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_38_4; }
    if (((token === import30.NgModel) && (38 === requestNodeIndex))) { return this._NgModel_38_5.context; }
    if (((token === import31.NgControl) && (38 === requestNodeIndex))) { return this._NgControl_38_6; }
    if (((token === import32.NgControlStatus) && (38 === requestNodeIndex))) { return this._NgControlStatus_38_7.context; }
    if (((token === import33.NgModelWc) && (38 === requestNodeIndex))) { return this._NgModelWc_38_8.context; }
    if (((token === import28.DefaultValueAccessor) && (42 === requestNodeIndex))) { return this._DefaultValueAccessor_42_3.context; }
    if (((token === import29.NG_VALUE_ACCESSOR) && (42 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_42_4; }
    if (((token === import30.NgModel) && (42 === requestNodeIndex))) { return this._NgModel_42_5.context; }
    if (((token === import31.NgControl) && (42 === requestNodeIndex))) { return this._NgControl_42_6; }
    if (((token === import32.NgControlStatus) && (42 === requestNodeIndex))) { return this._NgControlStatus_42_7.context; }
    if (((token === import33.NgModelWc) && (42 === requestNodeIndex))) { return this._NgModelWc_42_8.context; }
    if (((token === import25.TemplateRef) && (51 === requestNodeIndex))) { return this._TemplateRef_51_5; }
    if (((token === import38.NgIf) && (51 === requestNodeIndex))) { return this._NgIf_51_6.context; }
    if (((token === import25.TemplateRef) && (91 === requestNodeIndex))) { return this._TemplateRef_91_5; }
    if (((token === import38.NgIf) && (91 === requestNodeIndex))) { return this._NgIf_91_6.context; }
    if (((token === import25.TemplateRef) && (102 === requestNodeIndex))) { return this._TemplateRef_102_5; }
    if (((token === import38.NgIf) && (102 === requestNodeIndex))) { return this._NgIf_102_6.context; }
    if (((token === import25.TemplateRef) && (132 === requestNodeIndex))) { return this._TemplateRef_132_5; }
    if (((token === import27.NgFor) && (132 === requestNodeIndex))) { return this._NgFor_132_6.context; }
    if (((token === import25.TemplateRef) && (151 === requestNodeIndex))) { return this._TemplateRef_151_5; }
    if (((token === import27.NgFor) && (151 === requestNodeIndex))) { return this._NgFor_151_6.context; }
    if (((token === import25.TemplateRef) && (160 === requestNodeIndex))) { return this._TemplateRef_160_5; }
    if (((token === import38.NgIf) && (160 === requestNodeIndex))) { return this._NgIf_160_6.context; }
    if (((token === import25.TemplateRef) && (181 === requestNodeIndex))) { return this._TemplateRef_181_5; }
    if (((token === import27.NgFor) && (181 === requestNodeIndex))) { return this._NgFor_181_6.context; }
    if (((token === import39.NgClass) && ((165 <= requestNodeIndex) && (requestNodeIndex <= 201)))) { return this._NgClass_165_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_12_0_0:any = (this.context.data['dateType'].length > 0);
    this._NgIf_12_6.check_ngIf(currVal_12_0_0,throwOnChange,false);
    this._NgIf_12_6.ngDoCheck(this,this._anchor_12,throwOnChange);
    this._DefaultValueAccessor_20_3.ngDoCheck(this,this._el_20,throwOnChange);
    const currVal_20_1_0:any = 'Desde';
    this._NgModel_20_5.check_name(currVal_20_1_0,throwOnChange,false);
    const currVal_20_1_1:any = this.context.dateFrom;
    this._NgModel_20_5.check_model(currVal_20_1_1,throwOnChange,false);
    this._NgModel_20_5.ngDoCheck(this,this._el_20,throwOnChange);
    this._NgControlStatus_20_7.ngDoCheck(this,this._el_20,throwOnChange);
    this._NgModelWc_20_8.ngDoCheck(this,this._el_20,throwOnChange);
    this._DefaultValueAccessor_38_3.ngDoCheck(this,this._el_38,throwOnChange);
    const currVal_38_1_0:any = 'Hasta';
    this._NgModel_38_5.check_name(currVal_38_1_0,throwOnChange,false);
    const currVal_38_1_1:any = this.context.dateTo;
    this._NgModel_38_5.check_model(currVal_38_1_1,throwOnChange,false);
    this._NgModel_38_5.ngDoCheck(this,this._el_38,throwOnChange);
    this._NgControlStatus_38_7.ngDoCheck(this,this._el_38,throwOnChange);
    this._NgModelWc_38_8.ngDoCheck(this,this._el_38,throwOnChange);
    this._DefaultValueAccessor_42_3.ngDoCheck(this,this._el_42,throwOnChange);
    const currVal_42_1_0:any = 'Tipo de fecha';
    this._NgModel_42_5.check_name(currVal_42_1_0,throwOnChange,false);
    const currVal_42_1_1:any = this.context.rangeTypeSelect;
    this._NgModel_42_5.check_model(currVal_42_1_1,throwOnChange,false);
    this._NgModel_42_5.ngDoCheck(this,this._el_42,throwOnChange);
    this._NgControlStatus_42_7.ngDoCheck(this,this._el_42,throwOnChange);
    this._NgModelWc_42_8.ngDoCheck(this,this._el_42,throwOnChange);
    const currVal_51_0_0:any = (this.context.data['status'].length > 0);
    this._NgIf_51_6.check_ngIf(currVal_51_0_0,throwOnChange,false);
    this._NgIf_51_6.ngDoCheck(this,this._anchor_51,throwOnChange);
    const currVal_91_0_0:any = ((this.context.data['pointsOfSale'].length > 0) || !!this.context.data.posSelect);
    this._NgIf_91_6.check_ngIf(currVal_91_0_0,throwOnChange,false);
    this._NgIf_91_6.ngDoCheck(this,this._anchor_91,throwOnChange);
    const currVal_102_0_0:any = (this.context.data['paymentMethod'].length > 0);
    this._NgIf_102_6.check_ngIf(currVal_102_0_0,throwOnChange,false);
    this._NgIf_102_6.ngDoCheck(this,this._anchor_102,throwOnChange);
    const currVal_132_0_0:any = this.context.data.cities;
    this._NgFor_132_6.check_ngForOf(currVal_132_0_0,throwOnChange,false);
    this._NgFor_132_6.ngDoCheck(this,this._anchor_132,throwOnChange);
    const currVal_151_0_0:any = this.context.data.cities;
    this._NgFor_151_6.check_ngForOf(currVal_151_0_0,throwOnChange,false);
    this._NgFor_151_6.ngDoCheck(this,this._anchor_151,throwOnChange);
    const currVal_160_0_0:any = (this.context.data['placeOfPurchase'].length > 0);
    this._NgIf_160_6.check_ngIf(currVal_160_0_0,throwOnChange,false);
    this._NgIf_160_6.ngDoCheck(this,this._anchor_160,throwOnChange);
    const currVal_165_0_0:any = 'hidden-filters despegar-filters';
    this._NgClass_165_3.check_klass(currVal_165_0_0,throwOnChange,false);
    const currVal_165_0_1:any = this._map_346(this.context.hideDespegarFilters());
    this._NgClass_165_3.check_ngClass(currVal_165_0_1,throwOnChange,false);
    this._NgClass_165_3.ngDoCheck(this,this._el_165,throwOnChange);
    const currVal_181_0_0:any = this.context.data.companyNames;
    this._NgFor_181_6.check_ngForOf(currVal_181_0_0,throwOnChange,false);
    this._NgFor_181_6.ngDoCheck(this,this._anchor_181,throwOnChange);
    this._vc_12.detectChangesInNestedViews(throwOnChange);
    this._vc_51.detectChangesInNestedViews(throwOnChange);
    this._vc_91.detectChangesInNestedViews(throwOnChange);
    this._vc_102.detectChangesInNestedViews(throwOnChange);
    this._vc_132.detectChangesInNestedViews(throwOnChange);
    this._vc_151.detectChangesInNestedViews(throwOnChange);
    this._vc_160.detectChangesInNestedViews(throwOnChange);
    this._vc_181.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_258:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingList.filter.HIDE_ADVANCED')),' (',this.context.advancedFilters,')');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_258,currVal_258))) {
      this.renderer.setElementAttribute(this._el_2,'hide-filters-text',((currVal_258 == null)? (null as any): currVal_258.toString()));
      this._expr_258 = currVal_258;
    }
    valUnwrapper.reset();
    const currVal_260:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingList.filter.SHOW_ADVANCED')),'\n                            (',this.context.advancedFilters,')');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_260,currVal_260))) {
      this.renderer.setElementAttribute(this._el_2,'show-filters-text',((currVal_260 == null)? (null as any): currVal_260.toString()));
      this._expr_260 = currVal_260;
    }
    valUnwrapper.reset();
    const currVal_262:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('bookingList.filter.ERASE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_262,currVal_262))) {
      this.renderer.setElementAttribute(this._el_2,'delete-filters-text',((currVal_262 == null)? (null as any): currVal_262.toString()));
      this._expr_262 = currVal_262;
    }
    valUnwrapper.reset();
    const currVal_264:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('bookingList.filter.APPLY')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_264,currVal_264))) {
      this.renderer.setElementAttribute(this._el_2,'apply-filters-text',((currVal_264 == null)? (null as any): currVal_264.toString()));
      this._expr_264 = currVal_264;
    }
    valUnwrapper.reset();
    const currVal_266:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('bookingList.filter')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_266,currVal_266))) {
      this.renderer.setElementAttribute(this._el_2,'filters-title',((currVal_266 == null)? (null as any): currVal_266.toString()));
      this._expr_266 = currVal_266;
    }
    const currVal_268:any = import3.inlineInterpolate(1,'',this.context.disableApplyFilters,'');
    if (import3.checkBinding(throwOnChange,this._expr_268,currVal_268)) {
      this.renderer.setElementAttribute(this._el_2,'disabled',((currVal_268 == null)? (null as any): currVal_268.toString()));
      this._expr_268 = currVal_268;
    }
    const currVal_269:any = import3.inlineInterpolate(1,'',this.context.disableDatepicker,'');
    if (import3.checkBinding(throwOnChange,this._expr_269,currVal_269)) {
      this.renderer.setElementAttribute(this._el_20,'disabled',((currVal_269 == null)? (null as any): currVal_269.toString()));
      this._expr_269 = currVal_269;
    }
    valUnwrapper.reset();
    const currVal_270:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('bookingList.filter.DATE_FROM')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_270,currVal_270))) {
      this.renderer.setElementProperty(this._el_20,'placeholder',currVal_270);
      this._expr_270 = currVal_270;
    }
    valUnwrapper.reset();
    const currVal_272:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('bookingList.filter.DATE_RANGE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_272,currVal_272))) {
      this.renderer.setElementProperty(this._el_20,'label',currVal_272);
      this._expr_272 = currVal_272;
    }
    this._NgControlStatus_20_7.checkHost(this,this,this._el_20,throwOnChange);
    const currVal_275:boolean = !this.context.periodRange.from;
    if (import3.checkBinding(throwOnChange,this._expr_275,currVal_275)) {
      this.renderer.setElementProperty(this._el_22,'hidden',currVal_275);
      this._expr_275 = currVal_275;
    }
    valUnwrapper.reset();
    const currVal_276:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('bookingList.filter.error.rangeDate')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_276,currVal_276))) {
      this.renderer.setText(this._text_30,currVal_276);
      this._expr_276 = currVal_276;
    }
    const currVal_278:any = import3.inlineInterpolate(1,'',this.context.disableDatepicker,'');
    if (import3.checkBinding(throwOnChange,this._expr_278,currVal_278)) {
      this.renderer.setElementAttribute(this._el_38,'disabled',((currVal_278 == null)? (null as any): currVal_278.toString()));
      this._expr_278 = currVal_278;
    }
    valUnwrapper.reset();
    const currVal_279:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform('bookingList.filter.DATE_TO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_279,currVal_279))) {
      this.renderer.setElementProperty(this._el_38,'placeholder',currVal_279);
      this._expr_279 = currVal_279;
    }
    this._NgControlStatus_38_7.checkHost(this,this,this._el_38,throwOnChange);
    valUnwrapper.reset();
    const currVal_283:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_9.transform(('booking.dataType.' + this.context.dateTypeSelect))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_283,currVal_283))) {
      this.renderer.setElementAttribute(this._el_42,'filter-tag',((currVal_283 == null)? (null as any): currVal_283.toString()));
      this._expr_283 = currVal_283;
    }
    this._NgControlStatus_42_7.checkHost(this,this,this._el_42,throwOnChange);
    valUnwrapper.reset();
    const currVal_285:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_10.transform('bookingList.filter.BOOKING_OID')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_285,currVal_285))) {
      this.renderer.setElementAttribute(this._el_59,'filter-tag',((currVal_285 == null)? (null as any): currVal_285.toString()));
      this._expr_285 = currVal_285;
    }
    valUnwrapper.reset();
    const currVal_287:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_11.transform('bookingList.filter.BOOKING_OID')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_287,currVal_287))) {
      this.renderer.setElementProperty(this._el_59,'label',currVal_287);
      this._expr_287 = currVal_287;
    }
    valUnwrapper.reset();
    const currVal_289:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_12.transform('bookingList.filter.BOOKING_OID.PLACEHOLDER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_289,currVal_289))) {
      this.renderer.setElementProperty(this._el_59,'placeholder',currVal_289);
      this._expr_289 = currVal_289;
    }
    const currVal_291:any = 'md';
    if (import3.checkBinding(throwOnChange,this._expr_291,currVal_291)) {
      this.renderer.setElementProperty(this._el_59,'size',currVal_291);
      this._expr_291 = currVal_291;
    }
    const currVal_292:any = 'Campo invalido!';
    if (import3.checkBinding(throwOnChange,this._expr_292,currVal_292)) {
      this.renderer.setElementProperty(this._el_59,'invalid-text',currVal_292);
      this._expr_292 = currVal_292;
    }
    const currVal_293:any = 'top left';
    if (import3.checkBinding(throwOnChange,this._expr_293,currVal_293)) {
      this.renderer.setElementProperty(this._el_59,'invalid-position',currVal_293);
      this._expr_293 = currVal_293;
    }
    valUnwrapper.reset();
    const currVal_294:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_13.transform('bookingList.filter.FENIX_OID')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_294,currVal_294))) {
      this.renderer.setElementAttribute(this._el_64,'filter-tag',((currVal_294 == null)? (null as any): currVal_294.toString()));
      this._expr_294 = currVal_294;
    }
    valUnwrapper.reset();
    const currVal_296:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_14.transform('bookingList.filter.FENIX_OID')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_296,currVal_296))) {
      this.renderer.setElementProperty(this._el_64,'label',currVal_296);
      this._expr_296 = currVal_296;
    }
    valUnwrapper.reset();
    const currVal_298:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_15.transform('bookingList.filter.FENIX_OID.PLACEHOLDER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_298,currVal_298))) {
      this.renderer.setElementProperty(this._el_64,'placeholder',currVal_298);
      this._expr_298 = currVal_298;
    }
    const currVal_300:any = 'md';
    if (import3.checkBinding(throwOnChange,this._expr_300,currVal_300)) {
      this.renderer.setElementProperty(this._el_64,'size',currVal_300);
      this._expr_300 = currVal_300;
    }
    const currVal_301:any = 'Campo invalido!';
    if (import3.checkBinding(throwOnChange,this._expr_301,currVal_301)) {
      this.renderer.setElementProperty(this._el_64,'invalid-text',currVal_301);
      this._expr_301 = currVal_301;
    }
    const currVal_302:any = 'top left';
    if (import3.checkBinding(throwOnChange,this._expr_302,currVal_302)) {
      this.renderer.setElementProperty(this._el_64,'invalid-position',currVal_302);
      this._expr_302 = currVal_302;
    }
    valUnwrapper.reset();
    const currVal_303:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_16.transform('bookingList.filter.USERNAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_303,currVal_303))) {
      this.renderer.setElementAttribute(this._el_73,'filter-tag',((currVal_303 == null)? (null as any): currVal_303.toString()));
      this._expr_303 = currVal_303;
    }
    valUnwrapper.reset();
    const currVal_305:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_17.transform('bookingList.filter.USERNAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_305,currVal_305))) {
      this.renderer.setElementProperty(this._el_73,'label',currVal_305);
      this._expr_305 = currVal_305;
    }
    valUnwrapper.reset();
    const currVal_307:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_18.transform('bookingList.filter.USERNAME.PLACEHOLDER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_307,currVal_307))) {
      this.renderer.setElementProperty(this._el_73,'placeholder',currVal_307);
      this._expr_307 = currVal_307;
    }
    const currVal_309:any = 'md';
    if (import3.checkBinding(throwOnChange,this._expr_309,currVal_309)) {
      this.renderer.setElementProperty(this._el_73,'size',currVal_309);
      this._expr_309 = currVal_309;
    }
    const currVal_310:any = 'Campo invalido!';
    if (import3.checkBinding(throwOnChange,this._expr_310,currVal_310)) {
      this.renderer.setElementProperty(this._el_73,'invalid-text',currVal_310);
      this._expr_310 = currVal_310;
    }
    const currVal_311:any = 'top left';
    if (import3.checkBinding(throwOnChange,this._expr_311,currVal_311)) {
      this.renderer.setElementProperty(this._el_73,'invalid-position',currVal_311);
      this._expr_311 = currVal_311;
    }
    valUnwrapper.reset();
    const currVal_312:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_19.transform('bookingList.filter.LASTNAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_312,currVal_312))) {
      this.renderer.setElementAttribute(this._el_78,'filter-tag',((currVal_312 == null)? (null as any): currVal_312.toString()));
      this._expr_312 = currVal_312;
    }
    valUnwrapper.reset();
    const currVal_314:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_20.transform('bookingList.filter.LASTNAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_314,currVal_314))) {
      this.renderer.setElementProperty(this._el_78,'label',currVal_314);
      this._expr_314 = currVal_314;
    }
    valUnwrapper.reset();
    const currVal_316:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_21.transform('bookingList.filter.LASTNAME.PLACEHOLDER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_316,currVal_316))) {
      this.renderer.setElementProperty(this._el_78,'placeholder',currVal_316);
      this._expr_316 = currVal_316;
    }
    const currVal_318:any = 'md';
    if (import3.checkBinding(throwOnChange,this._expr_318,currVal_318)) {
      this.renderer.setElementProperty(this._el_78,'size',currVal_318);
      this._expr_318 = currVal_318;
    }
    const currVal_319:any = 'Campo invalido!';
    if (import3.checkBinding(throwOnChange,this._expr_319,currVal_319)) {
      this.renderer.setElementProperty(this._el_78,'invalid-text',currVal_319);
      this._expr_319 = currVal_319;
    }
    const currVal_320:any = 'top left';
    if (import3.checkBinding(throwOnChange,this._expr_320,currVal_320)) {
      this.renderer.setElementProperty(this._el_78,'invalid-position',currVal_320);
      this._expr_320 = currVal_320;
    }
    valUnwrapper.reset();
    const currVal_321:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_22.transform('bookingList.filter.EMAIL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_321,currVal_321))) {
      this.renderer.setElementAttribute(this._el_111,'filter-tag',((currVal_321 == null)? (null as any): currVal_321.toString()));
      this._expr_321 = currVal_321;
    }
    valUnwrapper.reset();
    const currVal_323:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_23.transform('bookingList.filter.EMAIL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_323,currVal_323))) {
      this.renderer.setElementProperty(this._el_111,'label',currVal_323);
      this._expr_323 = currVal_323;
    }
    valUnwrapper.reset();
    const currVal_325:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_24.transform('bookingList.filter.EMAIL.PLACEHOLDER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_325,currVal_325))) {
      this.renderer.setElementProperty(this._el_111,'placeholder',currVal_325);
      this._expr_325 = currVal_325;
    }
    const currVal_327:any = 'md';
    if (import3.checkBinding(throwOnChange,this._expr_327,currVal_327)) {
      this.renderer.setElementProperty(this._el_111,'size',currVal_327);
      this._expr_327 = currVal_327;
    }
    const currVal_328:any = 'Campo invalido!';
    if (import3.checkBinding(throwOnChange,this._expr_328,currVal_328)) {
      this.renderer.setElementProperty(this._el_111,'invalid-text',currVal_328);
      this._expr_328 = currVal_328;
    }
    const currVal_329:any = 'top left';
    if (import3.checkBinding(throwOnChange,this._expr_329,currVal_329)) {
      this.renderer.setElementProperty(this._el_111,'invalid-position',currVal_329);
      this._expr_329 = currVal_329;
    }
    valUnwrapper.reset();
    const currVal_330:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_25.transform('bookingList.filter.PICKUP_CITY')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_330,currVal_330))) {
      this.renderer.setElementAttribute(this._el_122,'filter-tag',((currVal_330 == null)? (null as any): currVal_330.toString()));
      this._expr_330 = currVal_330;
    }
    valUnwrapper.reset();
    const currVal_332:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_26.transform('bookingList.filter.PICKUP_CITY')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_332,currVal_332))) {
      this.renderer.setElementProperty(this._el_122,'label',currVal_332);
      this._expr_332 = currVal_332;
    }
    valUnwrapper.reset();
    const currVal_334:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_27.transform('bookingList.filter.PICKUP_CITY.PLACEHOLDER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_334,currVal_334))) {
      this.renderer.setElementProperty(this._el_122,'placeholder',currVal_334);
      this._expr_334 = currVal_334;
    }
    valUnwrapper.reset();
    const currVal_336:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_28.transform('common.SEARCH')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_336,currVal_336))) {
      this.renderer.setText(this._text_129,currVal_336);
      this._expr_336 = currVal_336;
    }
    valUnwrapper.reset();
    const currVal_338:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_29.transform('bookingList.filter.DROPOFF_CITY')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_338,currVal_338))) {
      this.renderer.setElementAttribute(this._el_141,'filter-tag',((currVal_338 == null)? (null as any): currVal_338.toString()));
      this._expr_338 = currVal_338;
    }
    valUnwrapper.reset();
    const currVal_340:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_30.transform('bookingList.filter.DROPOFF_CITY')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_340,currVal_340))) {
      this.renderer.setElementProperty(this._el_141,'label',currVal_340);
      this._expr_340 = currVal_340;
    }
    valUnwrapper.reset();
    const currVal_342:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_31.transform('bookingList.filter.DROPOFF_CITY.PLACEHOLDER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_342,currVal_342))) {
      this.renderer.setElementProperty(this._el_141,'placeholder',currVal_342);
      this._expr_342 = currVal_342;
    }
    valUnwrapper.reset();
    const currVal_344:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_32.transform('common.SEARCH')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_344,currVal_344))) {
      this.renderer.setText(this._text_148,currVal_344);
      this._expr_344 = currVal_344;
    }
    const currVal_347:any = this.context.hideDespegarFilters();
    if (import3.checkBinding(throwOnChange,this._expr_347,currVal_347)) {
      this.renderer.setElementProperty(this._el_169,'hidden',currVal_347);
      this._expr_347 = currVal_347;
    }
    valUnwrapper.reset();
    const currVal_348:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_33.transform('bookingList.filter.COMPANY_NAME.PLACEHOLDER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_348,currVal_348))) {
      this.renderer.setElementProperty(this._el_171,'placeholder',currVal_348);
      this._expr_348 = currVal_348;
    }
    valUnwrapper.reset();
    const currVal_350:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_34.transform('bookingList.filter.COMPANY_NAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_350,currVal_350))) {
      this.renderer.setElementAttribute(this._el_171,'filter-tag',((currVal_350 == null)? (null as any): currVal_350.toString()));
      this._expr_350 = currVal_350;
    }
    valUnwrapper.reset();
    const currVal_352:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_35.transform('bookingList.filter.COMPANY_NAME')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_352,currVal_352))) {
      this.renderer.setElementProperty(this._el_171,'label',currVal_352);
      this._expr_352 = currVal_352;
    }
    valUnwrapper.reset();
    const currVal_354:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_36.transform('common.SEARCH')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_354,currVal_354))) {
      this.renderer.setText(this._text_178,currVal_354);
      this._expr_354 = currVal_354;
    }
    const currVal_356:any = this.context.hideDespegarFilters();
    if (import3.checkBinding(throwOnChange,this._expr_356,currVal_356)) {
      this.renderer.setElementProperty(this._el_188,'hidden',currVal_356);
      this._expr_356 = currVal_356;
    }
    valUnwrapper.reset();
    const currVal_357:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_37.transform('bookingList.filter.COMPANY_OID')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_357,currVal_357))) {
      this.renderer.setElementAttribute(this._el_190,'filter-tag',((currVal_357 == null)? (null as any): currVal_357.toString()));
      this._expr_357 = currVal_357;
    }
    valUnwrapper.reset();
    const currVal_359:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_38.transform('bookingList.filter.COMPANY_OID')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_359,currVal_359))) {
      this.renderer.setElementProperty(this._el_190,'label',currVal_359);
      this._expr_359 = currVal_359;
    }
    valUnwrapper.reset();
    const currVal_361:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_39.transform('bookingList.filter.COMPANY_OID.PLACEHOLDER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_361,currVal_361))) {
      this.renderer.setElementProperty(this._el_190,'placeholder',currVal_361);
      this._expr_361 = currVal_361;
    }
    const currVal_363:any = 'md';
    if (import3.checkBinding(throwOnChange,this._expr_363,currVal_363)) {
      this.renderer.setElementProperty(this._el_190,'size',currVal_363);
      this._expr_363 = currVal_363;
    }
    const currVal_364:any = 'Campo invalido!';
    if (import3.checkBinding(throwOnChange,this._expr_364,currVal_364)) {
      this.renderer.setElementProperty(this._el_190,'invalid-text',currVal_364);
      this._expr_364 = currVal_364;
    }
    const currVal_365:any = 'top left';
    if (import3.checkBinding(throwOnChange,this._expr_365,currVal_365)) {
      this.renderer.setElementProperty(this._el_190,'invalid-position',currVal_365);
      this._expr_365 = currVal_365;
    }
    const currVal_366:any = this.context.hideDespegarFilters();
    if (import3.checkBinding(throwOnChange,this._expr_366,currVal_366)) {
      this.renderer.setElementProperty(this._el_196,'hidden',currVal_366);
      this._expr_366 = currVal_366;
    }
    const currVal_367:any = 'sm';
    if (import3.checkBinding(throwOnChange,this._expr_367,currVal_367)) {
      this.renderer.setElementProperty(this._el_198,'size',currVal_367);
      this._expr_367 = currVal_367;
    }
    valUnwrapper.reset();
    const currVal_368:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_40.transform('bookingList.filter.TEST')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_368,currVal_368))) {
      this.renderer.setElementAttribute(this._el_198,'filter-tag',((currVal_368 == null)? (null as any): currVal_368.toString()));
      this._expr_368 = currVal_368;
    }
    valUnwrapper.reset();
    const currVal_370:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_41.transform('bookingList.filter.TEST')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_370,currVal_370))) {
      this.renderer.setElementProperty(this._el_198,'label',currVal_370);
      this._expr_370 = currVal_370;
    }
    if (!throwOnChange) {
      if (this._viewQuery_selectDateRange_2.dirty) {
          this._viewQuery_selectDateRange_2.reset([this._vc_12.mapNestedViews(View_BookingFilterComponent1,(nestedView:View_BookingFilterComponent1):any => {
            return [new import17.ElementRef(nestedView._el_0)];
        })]);
        this.context.selectDateRange = this._viewQuery_selectDateRange_2.first;
      }
      if (this._viewQuery_pointOfSale_7.dirty) {
          this._viewQuery_pointOfSale_7.reset([this._vc_91.mapNestedViews(View_BookingFilterComponent5,(nestedView:View_BookingFilterComponent5):any => {
            return [new import17.ElementRef(nestedView._el_0)];
        })]);
        this.context.pointOfSale = this._viewQuery_pointOfSale_7.first;
      }
    }
  }
  destroyInternal():void {
    this._vc_12.destroyNestedViews();
    this._vc_51.destroyNestedViews();
    this._vc_91.destroyNestedViews();
    this._vc_102.destroyNestedViews();
    this._vc_132.destroyNestedViews();
    this._vc_151.destroyNestedViews();
    this._vc_160.destroyNestedViews();
    this._vc_181.destroyNestedViews();
    this._NgModel_20_5.ngOnDestroy();
    this._NgModelWc_20_8.ngOnDestroy();
    this._NgModel_38_5.ngOnDestroy();
    this._NgModelWc_38_8.ngOnDestroy();
    this._NgModel_42_5.ngOnDestroy();
    this._NgModelWc_42_8.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
    this._pipe_translate_10.ngOnDestroy();
    this._pipe_translate_11.ngOnDestroy();
    this._pipe_translate_12.ngOnDestroy();
    this._pipe_translate_13.ngOnDestroy();
    this._pipe_translate_14.ngOnDestroy();
    this._pipe_translate_15.ngOnDestroy();
    this._pipe_translate_16.ngOnDestroy();
    this._pipe_translate_17.ngOnDestroy();
    this._pipe_translate_18.ngOnDestroy();
    this._pipe_translate_19.ngOnDestroy();
    this._pipe_translate_20.ngOnDestroy();
    this._pipe_translate_21.ngOnDestroy();
    this._pipe_translate_22.ngOnDestroy();
    this._pipe_translate_23.ngOnDestroy();
    this._pipe_translate_24.ngOnDestroy();
    this._pipe_translate_25.ngOnDestroy();
    this._pipe_translate_26.ngOnDestroy();
    this._pipe_translate_27.ngOnDestroy();
    this._pipe_translate_28.ngOnDestroy();
    this._pipe_translate_29.ngOnDestroy();
    this._pipe_translate_30.ngOnDestroy();
    this._pipe_translate_31.ngOnDestroy();
    this._pipe_translate_32.ngOnDestroy();
    this._pipe_translate_33.ngOnDestroy();
    this._pipe_translate_34.ngOnDestroy();
    this._pipe_translate_35.ngOnDestroy();
    this._pipe_translate_36.ngOnDestroy();
    this._pipe_translate_37.ngOnDestroy();
    this._pipe_translate_38.ngOnDestroy();
    this._pipe_translate_39.ngOnDestroy();
    this._pipe_translate_40.ngOnDestroy();
    this._pipe_translate_41.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 12)) { return new View_BookingFilterComponent1(this.viewUtils,this,12,this._anchor_12,this._vc_12); }
    if ((nodeIndex == 51)) { return new View_BookingFilterComponent3(this.viewUtils,this,51,this._anchor_51,this._vc_51); }
    if ((nodeIndex == 91)) { return new View_BookingFilterComponent5(this.viewUtils,this,91,this._anchor_91,this._vc_91); }
    if ((nodeIndex == 102)) { return new View_BookingFilterComponent7(this.viewUtils,this,102,this._anchor_102,this._vc_102); }
    if ((nodeIndex == 132)) { return new View_BookingFilterComponent9(this.viewUtils,this,132,this._anchor_132,this._vc_132); }
    if ((nodeIndex == 151)) { return new View_BookingFilterComponent10(this.viewUtils,this,151,this._anchor_151,this._vc_151); }
    if ((nodeIndex == 160)) { return new View_BookingFilterComponent11(this.viewUtils,this,160,this._anchor_160,this._vc_160); }
    if ((nodeIndex == 181)) { return new View_BookingFilterComponent13(this.viewUtils,this,181,this._anchor_181,this._vc_181); }
    return (null as any);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'filtersApplied')) {
      const pd_sub_0:any = ((<any>this.context.appliedFilters($event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'filterRemoved')) {
      const pd_sub_1:any = ((<any>this.context.removedFilter($event)) !== false);
      result = (pd_sub_1 && result);
    }
    if ((eventName == 'filtersRemoved')) {
      const pd_sub_2:any = ((<any>this.context.removedFilters($event)) !== false);
      result = (pd_sub_2 && result);
    }
    if ((eventName == 'showAdvancedFilters')) {
      const pd_sub_3:any = ((<any>this.context.showAdvancedFilters($event)) !== false);
      result = (pd_sub_3 && result);
    }
    return result;
  }
  handleEvent_20(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_20_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.validateDateRange($event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'ngModelChange')) {
      const pd_sub_1:any = ((<any>(this.context.dateFrom = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_38(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_38_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'change')) {
      const pd_sub_0:any = ((<any>this.context.checkDateToValue($event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'click')) {
      const pd_sub_1:any = ((<any>this.context.validateDateRange($event)) !== false);
      result = (pd_sub_1 && result);
    }
    if ((eventName == 'ngModelChange')) {
      const pd_sub_2:any = ((<any>(this.context.dateTo = $event)) !== false);
      result = (pd_sub_2 && result);
    }
    return result;
  }
  handleEvent_42(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_42_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'ngModelChange')) {
      const pd_sub_0:any = ((<any>(this.context.rangeTypeSelect = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_122(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'search')) {
      const pd_sub_0:any = ((<any>this.context.searchCities($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_141(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'search')) {
      const pd_sub_0:any = ((<any>this.context.searchCities($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_171(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'itemSelected')) {
      const pd_sub_0:any = ((<any>this.context.getCompanyOidByName($event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'search')) {
      const pd_sub_1:any = ((<any>this.context.searchCompany($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_190(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'focusout')) {
      const pd_sub_0:any = ((<any>this.context.getCompanyOidById($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_198(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'change')) {
      const pd_sub_0:any = ((<any>this.context.applyTestFilter($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/booking/filter/booking-filter.component.ngfactory.ts